import React, { useState, useEffect, useRef } from "react";

// ============================================================
// CANADA PROVINCES
// ============================================================
const CANADA_PROVINCES = [
  { code: "AB", name: "Alberta",               gst: 5, pst: 0,   hst: 0,  qst: 0,     taxType: "GST"     },
  { code: "BC", name: "British Columbia",        gst: 5, pst: 7,   hst: 0,  qst: 0,     taxType: "GST+PST" },
  { code: "MB", name: "Manitoba",                gst: 5, pst: 7,   hst: 0,  qst: 0,     taxType: "GST+PST" },
  { code: "NB", name: "New Brunswick",           gst: 0, pst: 0,   hst: 15, qst: 0,     taxType: "HST"     },
  { code: "NL", name: "Newfoundland & Labrador", gst: 0, pst: 0,   hst: 15, qst: 0,     taxType: "HST"     },
  { code: "NS", name: "Nova Scotia",               gst: 0, pst: 0,   hst: 15, qst: 0,     taxType: "HST"     },
  { code: "NT", name: "Northwest Territories",   gst: 5, pst: 0,   hst: 0,  qst: 0,     taxType: "GST"     },
  { code: "NU", name: "Nunavut",                  gst: 5, pst: 0,   hst: 0,  qst: 0,     taxType: "GST"     },
  { code: "ON", name: "Ontario",                  gst: 0, pst: 0,   hst: 13, qst: 0,     taxType: "HST"     },
  { code: "PE", name: "Prince Edward Island",     gst: 0, pst: 0,   hst: 15, qst: 0,     taxType: "HST"     },
  { code: "QC", name: "Quebec",                    gst: 5, pst: 0,   hst: 0,  qst: 9.975, taxType: "GST+QST" },
  { code: "SK", name: "Saskatchewan",             gst: 5, pst: 6,   hst: 0,  qst: 0,     taxType: "GST+PST" },
  { code: "YT", name: "Yukon",                     gst: 5, pst: 0,   hst: 0,  qst: 0,     taxType: "GST"     },
];

// ============================================================
// TEMPLATE PREVIEW COMPONENTS
// ============================================================
const PreviewMaple = () => (
  <div style={{ background: '#fff0f3', border: '1.5px solid #c41e3a', borderRadius: 6, overflow: 'hidden', fontSize: 9, minHeight: 130 }}>
    <div style={{ background: 'linear-gradient(135deg,#c41e3a,#9b1429)', padding: '7px 10px' }}>
      <div style={{ color: '#fff', fontWeight: 700, fontSize: 11 }}>🍁 Business Name</div>
      <div style={{ background: 'rgba(255,255,255,0.3)', height: 5, width: '45%', borderRadius: 2, marginTop: 3 }} />
    </div>
    <div style={{ padding: '5px 8px' }}>
      <div style={{ display: 'flex', gap: 4, marginBottom: 4 }}>
        <div style={{ flex: 1, background: '#fff0f3', borderLeft: '3px solid #c41e3a', padding: '3px 4px', borderRadius: '0 3px 3px 0' }}>
          <div style={{ background: '#fecdd6', height: 4, width: '70%', borderRadius: 2, marginBottom: 2 }} />
          <div style={{ background: '#ffe4e9', height: 4, width: '85%', borderRadius: 2 }} />
        </div>
        <div style={{ flex: 1, background: '#fff0f3', borderLeft: '3px solid #c41e3a', padding: '3px 4px', borderRadius: '0 3px 3px 0' }}>
          <div style={{ background: '#fecdd6', height: 4, width: '70%', borderRadius: 2, marginBottom: 2 }} />
          <div style={{ background: '#ffe4e9', height: 4, width: '85%', borderRadius: 2 }} />
        </div>
      </div>
      <div style={{ background: '#c41e3a', height: 11, borderRadius: 2, marginBottom: 3 }} />
      <div style={{ background: '#fff0f3', height: 7, borderRadius: 2, marginBottom: 2 }} />
      <div style={{ background: '#ffe4e9', height: 7, borderRadius: 2, marginBottom: 4 }} />
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 8, fontWeight: 700, color: '#c41e3a' }}>
        <span style={{ background: '#fecdd6', height: 5, width: '30%', borderRadius: 2, display: 'inline-block', marginTop: 2 }} />
        <span>CA$ 1,000.00</span>
      </div>
    </div>
  </div>
);

const PreviewArctic = () => (
  <div style={{ background: '#f0f9ff', border: '1px solid #0ea5e9', borderRadius: 6, overflow: 'hidden', fontSize: 9, minHeight: 130 }}>
    <div style={{ background: '#0c4a6e', padding: '7px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div>
        <div style={{ color: '#fff', fontWeight: 700, fontSize: 10 }}>Business Name</div>
        <div style={{ color: '#7dd3fc', fontSize: 7, letterSpacing: 1 }}>CANADA TAX INVOICE</div>
      </div>
      <div style={{ background: '#0ea5e9', color: '#fff', fontSize: 7, fontWeight: 700, padding: '2px 6px', borderRadius: 20 }}>GST/HST</div>
    </div>
    <div style={{ padding: '5px 8px' }}>
      <div style={{ display: 'flex', gap: 4, marginBottom: 4 }}>
        <div style={{ flex: 1 }}><div style={{ background: '#bae6fd', height: 4, width: '65%', borderRadius: 2, marginBottom: 2 }} /><div style={{ background: '#e0f2fe', height: 4, width: '80%', borderRadius: 2 }} /></div>
        <div style={{ flex: 1 }}><div style={{ background: '#bae6fd', height: 4, width: '65%', borderRadius: 2, marginBottom: 2 }} /><div style={{ background: '#e0f2fe', height: 4, width: '80%', borderRadius: 2 }} /></div>
      </div>
      <div style={{ background: '#0ea5e9', height: 11, borderRadius: 2, marginBottom: 3 }} />
      <div style={{ background: '#f0f9ff', height: 7, border: '1px solid #bae6fd', borderRadius: 2, marginBottom: 2 }} />
      <div style={{ background: '#e0f2fe', height: 7, borderRadius: 2, marginBottom: 4 }} />
      <div style={{ display: 'flex', justifyContent: 'flex-end', fontSize: 8, fontWeight: 700, color: '#0c4a6e' }}>CA$ 1,000.00</div>
    </div>
  </div>
);

const PreviewFormal = () => (
  <div style={{ background: '#fff', border: '2px solid #1e293b', borderRadius: 4, padding: 8, fontSize: 9, minHeight: 130 }}>
    <div style={{ background: '#1e293b', color: '#fff', padding: '4px 6px', marginBottom: 5, textAlign: 'center', fontSize: 9, fontWeight: 700, letterSpacing: 1, borderRadius: 2 }}>CANADA TAX INVOICE</div>
    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5, fontSize: 8 }}>
      <div style={{ background: '#e2e8f0', height: 5, width: '45%', borderRadius: 2 }} />
      <div style={{ background: '#e2e8f0', height: 5, width: '25%', borderRadius: 2 }} />
    </div>
    <div style={{ background: '#1e293b', height: 13, borderRadius: 2, marginBottom: 3 }} />
    <div style={{ background: '#f8fafc', height: 9, borderRadius: 2, marginBottom: 2 }} />
    <div style={{ background: '#f1f5f9', height: 9, borderRadius: 2, marginBottom: 5 }} />
    <div style={{ borderTop: '2px solid #1e293b', paddingTop: 4, display: 'flex', justifyContent: 'space-between', fontSize: 8, fontWeight: 700 }}>
      <span style={{ background: '#e2e8f0', height: 5, width: '35%', borderRadius: 2, display: 'inline-block', marginTop: 2 }} />
      <span>CA$ 1,000.00</span>
    </div>
  </div>
);

const PreviewModern = () => (
  <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, overflow: 'hidden', fontSize: 9, minHeight: 130 }}>
    <div style={{ background: '#0f172a', padding: '7px 9px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div style={{ color: '#fff', fontWeight: 700, fontSize: 10 }}>Business Name</div>
      <div style={{ background: '#2563eb', color: '#fff', fontSize: 7, fontWeight: 700, padding: '2px 6px', borderRadius: 20 }}>INVOICE</div>
    </div>
    <div style={{ padding: '5px 8px' }}>
      <div style={{ display: 'flex', gap: 4, marginBottom: 4 }}>
        <div style={{ flex: 1, background: '#fff', border: '1px solid #e2e8f0', padding: 3, borderRadius: 3 }}>
          <div style={{ background: '#2563eb', height: 3, width: '50%', borderRadius: 2, marginBottom: 2 }} />
          <div style={{ background: '#e2e8f0', height: 3, width: '75%', borderRadius: 2 }} />
        </div>
        <div style={{ flex: 1, background: '#fff', border: '1px solid #e2e8f0', padding: 3, borderRadius: 3 }}>
          <div style={{ background: '#2563eb', height: 3, width: '50%', borderRadius: 2, marginBottom: 2 }} />
          <div style={{ background: '#e2e8f0', height: 3, width: '75%', borderRadius: 2 }} />
        </div>
      </div>
      <div style={{ background: '#0f172a', height: 11, borderRadius: 3, marginBottom: 3 }} />
      <div style={{ background: '#fff', height: 7, border: '1px solid #e2e8f0', borderRadius: 2, marginBottom: 2 }} />
      <div style={{ background: '#f1f5f9', height: 7, borderRadius: 2, marginBottom: 4 }} />
      <div style={{ background: '#0f172a', borderRadius: 4, padding: '2px 5px', display: 'flex', justifyContent: 'space-between' }}>
        <span style={{ background: '#374151', height: 4, width: '25%', borderRadius: 2, display: 'inline-block' }} />
        <span style={{ color: '#60a5fa', fontWeight: 700, fontSize: 8 }}>CA$ 1,000.00</span>
      </div>
    </div>
  </div>
);

const PreviewElegant = () => (
  <div style={{ background: '#fffbeb', border: '1px solid #d97706', borderRadius: 6, overflow: 'hidden', fontSize: 9, minHeight: 130 }}>
    <div style={{ background: 'linear-gradient(135deg,#92400e,#d97706)', padding: '7px 10px' }}>
      <div style={{ color: '#fff', fontWeight: 700, fontSize: 11 }}>Business Name</div>
      <div style={{ background: 'rgba(255,255,255,0.3)', height: 4, width: '40%', borderRadius: 2, marginTop: 3 }} />
    </div>
    <div style={{ background: '#fef3c7', height: 11, display: 'flex', alignItems: 'center', paddingLeft: 8, gap: 4 }}>
      <div style={{ background: '#d97706', height: 4, width: '18%', borderRadius: 2     }} />
      <div style={{ background: '#fcd34d', height: 4, width: '12%', borderRadius: 2     }} />
    </div>
    <div style={{ padding: '5px 8px' }}>
      <div style={{ background: '#fcd34d', height: 11, borderRadius: 2, marginBottom: 3 }} />
      <div style={{ background: '#fff', height: 7, border: '1px solid #fde68a', borderRadius: 2, marginBottom: 2 }} />
      <div style={{ background: '#fffbeb', height: 7, border: '1px solid #fde68a', borderRadius: 2, marginBottom: 4 }} />
      <div style={{ textAlign: 'right', color: '#d97706', fontWeight: 700, fontSize: 8 }}>CA$ 1,000.00</div>
    </div>
  </div>
);

const PreviewGov = () => (
  <div style={{ background: '#fff', border: '1.5px solid #1e293b', borderRadius: 3, fontSize: 9, overflow: 'hidden', minHeight: 130 }}>
    <div style={{ background: '#c41e3a', height: 6 }} />
    <div style={{ padding: '6px 8px', borderBottom: '1px solid #e2e8f0' }}>
      <div style={{ fontWeight: 900, fontSize: 10, color: '#1e293b', letterSpacing: 0.5, textTransform: 'uppercase' }}>Company Name</div>
      <div style={{ background: '#1e293b', color: '#fff', fontSize: 7, fontWeight: 700, padding: '2px 5px', marginTop: 3 }}>CRA Compliant Tax Invoice</div>
    </div>
    <div style={{ display: 'flex', borderBottom: '1px solid #e2e8f0', fontSize: 8 }}>
      <div style={{ flex: 1, padding: '3px 6px', background: '#f1f5f9', textAlign: 'center', fontWeight: 700, color: '#1e293b', fontSize: 8 }}>ORIGINAL</div>
      <div style={{ flex: 1, padding: '3px 6px', borderLeft: '1px solid #e2e8f0', textAlign: 'right', fontWeight: 700, fontSize: 8 }}>HST REGISTERED</div>
    </div>
    <div style={{ padding: '4px 6px' }}>
      <div style={{ display: 'flex', gap: 3, marginBottom: 3 }}>
        <div style={{ flex: 1 }}><div style={{ background: '#e2e8f0', height: 4, width: '60%', borderRadius: 2, marginBottom: 2 }} /><div style={{ background: '#f1f5f9', height: 4, width: '80%', borderRadius: 2 }} /></div>
        <div style={{ flex: 1 }}><div style={{ background: '#e2e8f0', height: 4, width: '60%', borderRadius: 2, marginBottom: 2 }} /><div style={{ background: '#f1f5f9', height: 4, width: '80%', borderRadius: 2 }} /></div>
      </div>
      <div style={{ background: '#1e293b', height: 11, marginBottom: 2 }} />
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 8, fontWeight: 700, color: '#1e293b', marginTop: 3 }}>
        <span style={{ background: '#e2e8f0', height: 4, width: '28%', borderRadius: 2, display: 'inline-block', marginTop: 2 }} />
        <span>CA$ 1,000.00</span>
      </div>
    </div>
  </div>
);

const PreviewMinimal = () => (
  <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 4, padding: 8, fontSize: 9, minHeight: 130 }}>
    <div style={{ fontWeight: 700, fontSize: 11, marginBottom: 1, color: '#1a1a1a' }}>Business Name</div>
    <div style={{ color: '#888', fontSize: 8, marginBottom: 5 }}>Canada Tax Invoice · INV-001</div>
    <div style={{ display: 'flex', gap: 4, marginBottom: 4 }}>
      <div style={{ flex: 1, background: '#f1f5f9', height: 15, borderRadius: 2 }} />
      <div style={{ flex: 1, background: '#f1f5f9', height: 15, borderRadius: 2 }} />
    </div>
    <div style={{ background: '#f8fafc', borderRadius: 3, padding: '3px 5px', marginBottom: 4 }}>
      <div style={{ background: '#e2e8f0', height: 5, width: '60%', borderRadius: 2, marginBottom: 2 }} />
      <div style={{ background: '#e2e8f0', height: 5, width: '40%', borderRadius: 2 }} />
    </div>
    <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: 3, display: 'flex', justifyContent: 'space-between', fontSize: 8, fontWeight: 700, color: '#1a1a1a' }}>
      <span>GST/HST Incl.</span>
      <span>CA$ 1,000.00</span>
    </div>
  </div>
);

const PreviewTeal = () => (
  <div style={{ background: '#fff', border: '1px solid #0d9488', borderRadius: 6, overflow: 'hidden', fontSize: 9, minHeight: 130 }}>
    <div style={{ background: 'linear-gradient(135deg,#0f766e,#0d9488)', padding: '7px 10px' }}>
      <div style={{ color: '#fff', fontWeight: 700, fontSize: 11 }}>Business Name</div>
      <div style={{ background: 'rgba(255,255,255,0.3)', height: 4, width: '40%', borderRadius: 2, marginTop: 3 }} />
    </div>
    <div style={{ background: '#134e4a', height: 9, display: 'flex', alignItems: 'center', paddingLeft: 8, gap: 5 }}>
      <div style={{ background: '#5eead4', height: 4, width: '18%', borderRadius: 2 }} />
      <div style={{ background: '#99f6e4', height: 4, width: '12%', borderRadius: 2 }} />
    </div>
    <div style={{ padding: '5px 8px' }}>
      <div style={{ display: 'flex', gap: 4, marginBottom: 4 }}>
        <div style={{ flex: 1, background: '#f0fdfa', borderLeft: '3px solid #0d9488', padding: '3px 4px', borderRadius: '0 3px 3px 0' }}>
          <div style={{ background: '#99f6e4', height: 4, width: '65%', borderRadius: 2, marginBottom: 2 }} />
          <div style={{ background: '#ccfbf1', height: 4, width: '80%', borderRadius: 2 }} />
        </div>
        <div style={{ flex: 1, background: '#f0fdfa', borderLeft: '3px solid #0d9488', padding: '3px 4px', borderRadius: '0 3px 3px 0' }}>
          <div style={{ background: '#99f6e4', height: 4, width: '65%', borderRadius: 2, marginBottom: 2 }} />
          <div style={{ background: '#ccfbf1', height: 4, width: '80%', borderRadius: 2 }} />
        </div>
      </div>
      <div style={{ background: '#0d9488', height: 9, borderRadius: 2, marginBottom: 2 }} />
      <div style={{ background: '#f0fdfa', height: 6, borderRadius: 2, marginBottom: 4 }} />
      <div style={{ background: '#0f766e', borderRadius: 3, padding: '2px 4px', display: 'flex', justifyContent: 'space-between' }}>
        <span style={{ background: '#134e4a', height: 4, width: '25%', borderRadius: 2, display: 'inline-block', marginTop: 1 }} />
        <span style={{ color: '#5eead4', fontWeight: 700, fontSize: 8 }}>CA$ 1,000.00</span>
      </div>
    </div>
  </div>
);

// ============================================================
// TEMPLATE DEFINITIONS
// ============================================================
const TEMPLATES = [
  { id: 'maple',   label: 'Maple',    isNew: true,  color: '#c41e3a', preview: <PreviewMaple /> },
  { id: 'arctic',  label: 'Arctic',   isNew: true,  color: '#0ea5e9', preview: <PreviewArctic /> },
  { id: 'formal',  label: 'Formal',                 color: '#1e293b', preview: <PreviewFormal /> },
  { id: 'modern',  label: 'Modern',                 color: '#2563eb', preview: <PreviewModern /> },
  { id: 'elegant', label: 'Elegant',  isNew: true,  color: '#d97706', preview: <PreviewElegant /> },
  { id: 'gov',     label: 'Official',               color: '#1e293b', preview: <PreviewGov /> },
  { id: 'minimal', label: 'Minimal',                color: '#64748b', preview: <PreviewMinimal /> },
  { id: 'teal',    label: 'Teal',                   color: '#0d9488', preview: <PreviewTeal /> },
];

// ============================================================
// CANADA TEMPLATE SELECTOR MODAL
// ============================================================
function CanadaTemplateSelector({ onClose, onSelect }) {
  const [selected, setSelected] = useState(null);

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Inter','Segoe UI',sans-serif" }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{ background: '#f8fafc', borderRadius: 16, width: 'min(700px,96vw)', maxHeight: '92vh', overflowY: 'auto', boxShadow: '0 30px 80px rgba(0,0,0,0.25)', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '18px 20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f8fafc', position: 'sticky', top: 0, zIndex: 1, borderBottom: '1px solid #e2e8f0', paddingBottom: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 20 }}>🍁</span>
            <span style={{ fontSize: 18, fontWeight: 700, color: '#0f172a' }}>Canada Invoice — Theme Gallery</span>
          </div>
          <button onClick={onClose} style={{ border: 'none', background: '#e2e8f0', borderRadius: '50%', width: 32, height: 32, fontSize: 18, cursor: 'pointer', color: '#475569', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
        </div>
        <div style={{ padding: '16px 20px', overflowY: 'auto' }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 16, marginBottom: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 12 }}>
              {TEMPLATES.map(t => {
                const isSel = selected === t.id;
                return (
                  <div
                    key={t.id}
                    onClick={() => setSelected(t.id)}
                    style={{ border: `2px solid ${isSel ? t.color : '#e2e8f0'}`, borderRadius: 12, padding: 10, cursor: 'pointer', background: isSel ? `${t.color}0d` : '#fafafa', transition: 'all 0.18s', boxShadow: isSel ? `0 0 0 3px ${t.color}33` : 'none', position: 'relative' }}
                  >
                    {t.isNew && (<div style={{ position: 'absolute', top: 8, left: 8, background: '#dc2626', color: '#fff', fontSize: 8, fontWeight: 800, padding: '2px 6px', borderRadius: 4, letterSpacing: 0.5, zIndex: 1 }}>NEW</div>)}
                    <div style={{ pointerEvents: 'none', marginBottom: 8 }}>{t.preview}</div>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontWeight: 600, fontSize: 13, color: '#0f172a' }}>{t.label}</div>
                      {isSel && (<div style={{ fontSize: 12, color: '#16a34a', fontWeight: 600, marginTop: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }}>✓ Selected</div>)}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div style={{ background: '#fff', borderRadius: 14, padding: '12px 16px', marginBottom: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.06)', display: 'flex', alignItems: 'center', gap: 10, fontSize: 12, color: '#374151' }}>
            <span style={{ fontSize: 20 }}>🍁</span>
            <span>All templates include <strong>GST / HST / PST / QST</strong> breakdown, CRA-compliant formatting, and CAD currency display.</span>
          </div>
        </div>
        <div style={{ padding: '14px 20px', background: '#fff', borderTop: '1px solid #e2e8f0', display: 'flex', gap: 10, justifyContent: 'flex-end', borderRadius: '0 0 16px 16px' }}>
          <button onClick={onClose} style={{ padding: '10px 22px', border: '1px solid #e2e8f0', background: '#fff', color: '#475569', borderRadius: 8, fontSize: 14, cursor: 'pointer', fontWeight: 500 }}>Cancel</button>
          <button
            onClick={() => { if (selected) { onClose(); onSelect(selected); } }}
            disabled={!selected}
            style={{ padding: '10px 24px', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: selected ? 'pointer' : 'not-allowed', background: selected ? '#c41e3a' : '#cbd5e1', color: '#fff', transition: 'all 0.18s', minWidth: 180 }}
          >
            🍁 Download PDF
          </button>
        </div>
      </div>
    </div>
  );
}

// ============================================================
// PDF TEMPLATE HELPERS
// ============================================================
const fmtCAD = (n, currency = 'CAD') =>
  `${currency === 'USD' ? 'US$' : 'CA$'} ${Number(n).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

function _taxRows(d) {
  const rows = [];
  if (d.hstAmt > 0) rows.push(`<tr><td style="padding:5px 0;color:#374151">HST @ ${d.taxProv?.hst}% (${d.taxProv?.name})</td><td style="text-align:right;padding:5px 0">${fmtCAD(d.hstAmt,d.currency)}</td></tr>`);
  if (d.gstAmt > 0) rows.push(`<tr><td style="padding:5px 0;color:#374151">GST @ ${d.taxProv?.gst}%</td><td style="text-align:right;padding:5px 0">${fmtCAD(d.gstAmt,d.currency)}</td></tr>`);
  if (d.pstAmt > 0) rows.push(`<tr><td style="padding:5px 0;color:#374151">PST @ ${d.taxProv?.pst}% (${d.taxProv?.name})</td><td style="text-align:right;padding:5px 0">${fmtCAD(d.pstAmt,d.currency)}</td></tr>`);
  if (d.qstAmt > 0) rows.push(`<tr><td style="padding:5px 0;color:#374151">QST @ ${d.taxProv?.qst}% (Quebec)</td><td style="text-align:right;padding:5px 0">${fmtCAD(d.qstAmt,d.currency)}</td></tr>`);
  return rows.join('');
}

function _taxBadge(d) {
  if (!d.taxProv) return '';
  const parts = [];
  if (d.taxProv.hst > 0) parts.push(`HST ${d.taxProv.hst}%`);
  if (d.taxProv.gst > 0) parts.push(`GST ${d.taxProv.gst}%`);
  if (d.taxProv.pst > 0) parts.push(`PST ${d.taxProv.pst}%`);
  if (d.taxProv.qst > 0) parts.push(`QST ${d.taxProv.qst}%`);
  return `<span style="font-size:11px;font-weight:700;color:#7c3aed">🍁 ${d.taxProv.name} — ${parts.join(' + ')}</span>`;
}

function _itemRows(d) {
  return d.items.map((it, i) => {
    const lineTotal = (parseFloat(String(it.qty)) || 0) * (parseFloat(it.rate) || 0);
    return `<tr style="border-bottom:1px solid #f3f4f6">
      <td style="padding:9px 8px;color:#374151">${i + 1}</td>
      <td style="padding:9px 8px;color:#111827">${it.description || ''}</td>
      <td style="padding:9px 8px;text-align:right;color:#374151">${parseFloat(String(it.qty)) || 0}</td>
      <td style="padding:9px 8px;text-align:right;color:#374151">${fmtCAD(parseFloat(it.rate) || 0, d.currency)}</td>
      <td style="padding:9px 8px;text-align:center;color:${it.taxable ? '#2563eb' : '#6b7280'};font-size:11px;font-weight:600">${it.taxable ? 'Yes' : 'No'}</td>
      <td style="padding:9px 8px;text-align:right;font-weight:600;color:#111827">${fmtCAD(lineTotal, d.currency)}</td>
    </tr>`;
  }).join('');
}

function _statusBadge(status) {
  const map = {
    PAID:   { color: '#059669', bg: '#f0fdf4', border: '#86efac', label: '✅ PAID' },
    UNPAID: { color: '#dc2626', bg: '#fff1f2', border: '#fecaca', label: '🔴 UNPAID' },
    DRAFT:  { color: '#2563eb', bg: '#eff6ff', border: '#bfdbfe', label: '📝 DRAFT' },
  };
  const s = map[status] || map.DRAFT;
  return `<span style="display:inline-block;padding:4px 14px;border-radius:6px;font-size:13px;font-weight:700;border:2px solid ${s.border};color:${s.color};background:${s.bg}">${s.label}</span>`;
}

function _watermark(status) {
  const map = { PAID: '#059669', UNPAID: '#dc2626', DRAFT: '#2563eb' };
  const labels = { PAID: 'PAID', UNPAID: 'UNPAID', DRAFT: 'DRAFT' };
  const color = map[status] || map.DRAFT;
  const label = labels[status] || 'DRAFT';
  return `<div style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) rotate(-30deg);font-size:90px;font-weight:900;color:${color};opacity:0.05;pointer-events:none;white-space:nowrap;z-index:0">${label}</div>`;
}

function _logoHtml(logoUrl, name, accent = '#2563eb', size = 64) {
  if (logoUrl)
    return `<img src="${logoUrl}" alt="Logo" style="max-height:${size}px;max-width:160px;object-fit:contain;border-radius:4px" onerror="this.style.display='none'">`;
  return `<div style="width:${size}px;height:${size}px;background:${accent};border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:${Math.round(size*0.4)}px;font-weight:900;color:#fff">${(name||'B')[0]}</div>`;
}

// Fixed line signature structure
function _signHtml(signUrl, name, width = 200) {
  const img = signUrl
    ? `<img src="${signUrl}" alt="Signature" style="max-height:60px;max-width:${width}px;object-fit:contain;display:block;" onerror="this.style.display='none'">`
    : `<div style="height:50px"></div>`;
  return `<div style="text-align:center;min-width:${width}px">
    ${img}
    <div style="border-top:1.5px solid #111827;padding-top:6px;font-size:12px;font-weight:700;color:#111827">For ${name || 'Your Business'}</div>
    <div style="font-size:11px;color:#6b7280;margin-top:2px">Authorized Signatory</div>
  </div>`;
}

function _infoBlock(party, isGreen = false) {
  const accent = isGreen ? '#059669' : '#2563eb';
  const bg     = isGreen ? '#f0fdf4' : '#eff6ff';
  const border = isGreen ? '#86efac' : '#bfdbfe';
  const lines  = [
    party.address,
    [party.city, party.province].filter(Boolean).join(', ') + (party.postalCode ? ' ' + party.postalCode : ''),
    party.country || 'Canada',
    party.phone,
    party.email,
    party.taxNumber ? `GST/HST #: ${party.taxNumber}` : '',
  ].filter(Boolean).join('<br>');
  return { bg, border, accent, lines };
}

function _summaryTable(d, accentColor = '#2563eb') {
  return `
    <table style="width:100%;font-size:13px;border-collapse:collapse">
      <tr><td style="padding:5px 0;color:#374151">Subtotal</td><td style="text-align:right;padding:5px 0">${fmtCAD(d.subtotal,d.currency)}</td></tr>
      ${_taxRows(d)}
      ${d.totalTax > 0 ? `<tr><td style="padding:5px 0;color:#7c3aed;font-weight:600">Total Tax</td><td style="text-align:right;padding:5px 0;color:#7c3aed;font-weight:600">${fmtCAD(d.totalTax,d.currency)}</td></tr>` : ''}
      <tr style="border-top:2px solid #e5e7eb">
        <td style="padding:10px 0 4px;font-size:15px;font-weight:700;color:#111827">Invoice Total</td>
        <td style="text-align:right;padding:10px 0 4px;font-size:20px;font-weight:800;color:${accentColor}">${fmtCAD(d.grandTotal,d.currency)}</td>
      </tr>
    </table>`;
}

function numberToWords(num) {
  if (num === 0) return 'Zero Dollars Only';
  const ones = ['','One','Two','Three','Four','Five','Six','Seven','Eight','Nine','Ten','Eleven','Twelve','Thirteen','Fourteen','Fifteen','Sixteen','Seventeen','Eighteen','Nineteen'];
  const tens = ['','','Twenty','Thirty','Forty','Fifty','Sixty','Seventy','Eighty','Ninety'];
  const convert = n => {
    if (n < 20) return ones[n];
    if (n < 100) return tens[Math.floor(n/10)] + (n%10?' '+ones[n%10]:'');
    if (n < 1000) return ones[Math.floor(n/100)]+' Hundred'+(n%100?' '+convert(n%100):'');
    if (n < 1000000) return convert(Math.floor(n/1000))+' Thousand'+(n%1000?' '+convert(n%1000):'');
    return convert(Math.floor(n/1000000))+' Million'+(n%1000000?' '+convert(n%1000000):'');
  };
  const r = Math.floor(num);
  const cents = Math.round((num - r)*100);
  let result = convert(r)+' Dollar'+(r!==1?'s':'');
  if (cents > 0) result += ' and '+convert(cents)+' Cent'+(cents!==1?'s':'');
  return result+' Only';
}

function _openPrint(html, filename) {
  const win = window.open('', '_blank', 'width=1100,height=850');
  if (!win) { alert('Popup blocked! Please allow popups for this site.'); return; }
  win.document.write(html);
  win.document.close();
  win.focus();
  setTimeout(() => {
    try {
      win.document.title = filename || 'Canada Tax Invoice';
      win.print();
    } catch(e) {}
  }, 700);
}

// ============================================================
// PDF TEMPLATE RENDERERS
// ============================================================
function tplMaple(d) {
  const s = _infoBlock(d.seller);
  const b = _infoBlock(d.buyer, true);
  return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Invoice ${d.invoicePrefix}-${d.invoiceNum}</title>
  <style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:'Segoe UI',Arial,sans-serif;font-size:12px;color:#111827;padding:36px 40px;max-width:860px;margin:0 auto}@media print{body{padding:18px}@page{margin:1cm}}</style></head><body>
  <div style="position:relative;overflow:hidden">
    ${_watermark(d.invoiceStatus)}
    <div style="position:relative;z-index:1">
      <div style="height:8px;background:linear-gradient(90deg,#c41e3a,#9b1429,#c41e3a);border-radius:4px;margin-bottom:24px"></div>
      <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:24px">
        <div style="display:flex;align-items:center;gap:16px">
          ${_logoHtml(d.businessLogoUrl, d.seller.businessName, '#c41e3a', 60)}
          <div>
            <div style="font-size:22px;font-weight:800;color:#111827">${d.seller.businessName || 'Business Name'}</div>
            <div style="font-size:11px;color:#c41e3a;font-weight:700;letter-spacing:1px;margin-top:3px">🍁 CRA COMPLIANT · CANADA TAX INVOICE</div>
          </div>
        </div>
        <div style="text-align:right">
          ${_statusBadge(d.invoiceStatus)}
          <table style="font-size:12px;border-collapse:collapse;margin-left:auto;margin-top:8px">
            <tr><td style="color:#6b7280;padding:2px 8px 2px 0">Invoice #:</td><td style="font-weight:700;font-family:monospace;color:#c41e3a">${d.invoicePrefix}-${d.invoiceNum}</td></tr>
            <tr><td style="color:#6b7280;padding:2px 8px 2px 0">Date:</td><td>${d.invoiceDate}</td></tr>
            <tr><td style="color:#6b7280;padding:2px 8px 2px 0">Due:</td><td style="font-weight:700;color:#dc2626">${d.dueDate}</td></tr>
            <tr><td style="color:#6b7280;padding:2px 8px 2px 0">Terms:</td><td>Net ${d.paymentTerms}</td></tr>
            <tr><td style="color:#6b7280;padding:2px 8px 2px 0">Currency:</td><td>${d.currency}</td></tr>
          </table>
        </div>
      </div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:20px">
        <div style="background:${s.bg};border:1px solid ${s.border};border-left:4px solid #c41e3a;border-radius:8px;padding:14px">
          <div style="font-size:10px;font-weight:700;color:#c41e3a;letter-spacing:1px;text-transform:uppercase;margin-bottom:6px">🏢 From (Seller)</div>
          <div style="font-size:14px;font-weight:700;color:#111827">${d.seller.businessName || '—'}</div>
          <div style="font-size:11px;color:#374151;line-height:1.8;margin-top:4px">${s.lines}</div>
        </div>
        <div style="background:${b.bg};border:1px solid ${b.border};border-left:4px solid #059669;border-radius:8px;padding:14px">
          <div style="font-size:10px;font-weight:700;color:#059669;letter-spacing:1px;text-transform:uppercase;margin-bottom:6px">👤 To (Buyer)</div>
          <div style="font-size:14px;font-weight:700;color:#111827">${d.buyer.businessName || '—'}</div>
          <div style="font-size:11px;color:#374151;line-height:1.8;margin-top:4px">${b.lines}</div>
        </div>
      </div>
      <table style="width:100%;border-collapse:collapse;font-size:13px;margin-bottom:20px">
        <thead><tr style="background:#c41e3a">${['#','Description','Qty','Rate','Tax?','Total'].map(h=>`<th style="padding:10px 8px;text-align:${['Qty','Rate','Tax?','Total'].includes(h)?'right':'left'};font-size:10px;font-weight:700;color:#fff;letter-spacing:0.5px;text-transform:uppercase">${h}</th>`).join('')}</tr></thead>
        <tbody>${_itemRows(d)}</tbody>
      </table>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:20px">
        <div style="background:#fff0f3;border:1px solid #fecdd6;border-left:4px solid #c41e3a;border-radius:8px;padding:16px">
          <div style="font-size:10px;font-weight:700;color:#c41e3a;letter-spacing:1px;margin-bottom:8px">AMOUNT IN WORDS</div>
          <div style="font-size:14px;font-weight:700;color:#111827;line-height:1.5">${numberToWords(d.grandTotal)}</div>
          <div style="margin-top:10px;font-size:11px;color:#6b7280">${_taxBadge(d)}</div>
        </div>
        <div style="background:#fff;border:1px solid #e5e7eb;border-radius:8px;padding:16px">${_summaryTable(d, '#c41e3a')}</div>
      </div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:16px">
        <div>
          <div style="font-size:10px;font-weight:700;color:#6b7280;letter-spacing:1px;margin-bottom:6px">TERMS & CONDITIONS</div>
          <div style="font-size:11px;color:#374151;line-height:1.8;background:#f9fafb;border-radius:6px;padding:10px;border:1px solid #e5e7eb;white-space:pre-line">${d.terms || ''}</div>
        </div>
        <div style="display:flex;flex-direction:column;align-items:flex-end;justify-content:flex-end">${_signHtml(d.businessSignatureUrl, d.seller.businessName)}</div>
      </div>
      <div style="height:8px;background:linear-gradient(90deg,#c41e3a,#9b1429,#c41e3a);border-radius:4px;margin-top:16px"></div>
      <div style="display:flex;justify-content:space-between;font-size:10px;color:#9ca3af;margin-top:10px">
        <span>🍁 CRA Compliant · GST/HST Ready · Excise Tax Act</span>
        <span>${d.invoicePrefix}-${d.invoiceNum} · ${d.currency}</span>
      </div>
    </div>
  </div>
  </body></html>`;
}

function tplArctic(d) {
  const s = _infoBlock(d.seller);
  const b = _infoBlock(d.buyer, true);
  return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Invoice ${d.invoicePrefix}-${d.invoiceNum}</title>
  <style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#0c4a6e;background:#f0f9ff;padding:0;max-width:900px;margin:0 auto}.page{background:#fff;border-radius:12px;overflow:hidden}@media print{body{background:#fff;padding:0}.page{border-radius:0}@page{margin:.8cm}}</style></head><body>
  <div class="page">
    <div style="background:#0c4a6e;padding:24px 32px;display:flex;justify-content:space-between;align-items:flex-start">
      <div style="display:flex;align-items:center;gap:16px">
        ${_logoHtml(d.businessLogoUrl, d.seller.businessName, '#0ea5e9', 60)}
        <div>
          <div style="font-size:24px;font-weight:700;color:#fff">${d.seller.businessName || 'Business Name'}</div>
          <div style="font-size:10px;color:#7dd3fc;margin-top:4px;line-height:1.7">${d.seller.address ? d.seller.address+' · ' : ''}${[d.seller.city,d.seller.province].filter(Boolean).join(', ')}</div>
          <div style="font-size:10px;color:#7dd3fc">${d.seller.email||''}${d.seller.phone?' · '+d.seller.phone:''}</div>
        </div>
      </div>
      <div style="text-align:right">
        <div style="font-size:10px;color:#7dd3fc;text-transform:uppercase;letter-spacing:2px">Tax Invoice</div>
        <div style="font-size:22px;font-weight:700;color:#0ea5e9;margin:4px 0">${d.invoicePrefix}-${d.invoiceNum}</div>
        <div style="font-size:11px;color:#bae6fd">${d.invoiceDate}</div>
        <div style="margin-top:8px">${_statusBadge(d.invoiceStatus)}</div>
      </div>
    </div>
    <div style="background:#0284c7;padding:6px 32px;display:flex;gap:20px;font-size:11px;color:#e0f2fe">
      <span>GST/HST: <strong style="color:#fff">${d.taxProv ? (d.taxProv.hst > 0 ? d.taxProv.hst+'% HST' : (d.taxProv.gst+d.taxProv.pst)+'% GST+PST') : 'N/A'}</strong></span>
      <span>Province: <strong style="color:#fff">${d.taxProv ? d.taxProv.name : '—'}</strong></span>
      <span>Terms: <strong style="color:#fff">Net ${d.paymentTerms}</strong></span>
      <span>Due: <strong style="color:#fff">${d.dueDate}</strong></span>
      <span>Currency: <strong style="color:#fff">${d.currency}</strong></span>
    </div>
    <div style="padding:24px 32px">
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:20px">
        <div style="background:#f0f9ff;border:1px solid #bae6fd;border-radius:8px;padding:14px">
          <div style="font-size:10px;font-weight:700;color:#0284c7;letter-spacing:1px;margin-bottom:6px">FROM</div>
          <div style="font-size:14px;font-weight:700;color:#0c4a6e">${d.seller.businessName || '—'}</div>
          <div style="font-size:11px;color:#374151;line-height:1.8;margin-top:4px">${s.lines}</div>
        </div>
        <div style="background:#f0fdf4;border:1px solid #86efac;border-radius:8px;padding:14px">
          <div style="font-size:10px;font-weight:700;color:#059669;letter-spacing:1px;margin-bottom:6px">TO</div>
          <div style="font-size:14px;font-weight:700;color:#111827">${d.buyer.businessName || '—'}</div>
          <div style="font-size:11px;color:#374151;line-height:1.8;margin-top:4px">${b.lines}</div>
        </div>
      </div>
      <table style="width:100%;border-collapse:collapse;font-size:13px;margin-bottom:20px">
        <thead><tr style="background:#0ea5e9">${['#','Description','Qty','Rate','Tax?','Total'].map(h=>`<th style="padding:10px 8px;text-align:${['Qty','Rate','Tax?','Total'].includes(h)?'right':'left'};font-size:10px;font-weight:700;color:#fff;text-transform:uppercase;letter-spacing:0.5px">${h}</th>`).join('')}</tr></thead>
        <tbody>${_itemRows(d)}</tbody>
      </table>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:20px">
        <div style="background:#f0f9ff;border:1px solid #bae6fd;border-radius:8px;padding:14px">
          <div style="font-size:10px;font-weight:700;color:#0284c7;letter-spacing:1px;margin-bottom:6px">AMOUNT IN WORDS</div>
          <div style="font-size:13px;font-weight:700;color:#0c4a6e;line-height:1.5">${numberToWords(d.grandTotal)}</div>
          <div style="margin-top:8px">${_taxBadge(d)}</div>
        </div>
        <div style="background:#fff;border:1px solid #e5e7eb;border-radius:8px;padding:14px">${_summaryTable(d, '#0284c7')}</div>
      </div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px">
        <div>
          <div style="font-size:10px;font-weight:700;color:#6b7280;letter-spacing:1px;margin-bottom:6px">TERMS & CONDITIONS</div>
          <div style="font-size:11px;color:#374151;line-height:1.8;white-space:pre-line;background:#f9fafb;border-radius:6px;padding:10px;border:1px solid #e5e7eb">${d.terms||''}</div>
        </div>
        <div style="display:flex;flex-direction:column;align-items:flex-end;justify-content:flex-end">${_signHtml(d.businessSignatureUrl, d.seller.businessName)}</div>
      </div>
    </div>
    <div style="background:#0c4a6e;padding:10px 32px;display:flex;justify-content:space-between;font-size:10px;color:#7dd3fc">
      <span>🍁 CRA Compliant · GST/HST · Excise Tax Act</span><span>${d.invoicePrefix}-${d.invoiceNum} · ${d.currency}</span>
    </div>
  </div>
  </body></html>`;
}

function tplFormal(d) {
  const s = _infoBlock(d.seller);
  const b = _infoBlock(d.buyer, true);
  return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Invoice ${d.invoicePrefix}-${d.invoiceNum}</title>
  <style>*{box-sizing:border-box}body{font-family:Georgia,'Times New Roman',serif;font-size:12px;color:#000;padding:28px 36px;max-width:900px;margin:0 auto}.ob{border:2px solid #000;padding:18px}@media print{body{padding:10px}@page{margin:1cm}}</style></head><body>
  <div class="ob">
    <div style="display:flex;justify-content:space-between;align-items:center;border-bottom:3px solid #000;padding-bottom:14px;margin-bottom:14px">
      <div style="display:flex;align-items:center;gap:14px">
        ${_logoHtml(d.businessLogoUrl, d.seller.businessName, '#1e293b', 56)}
        <div>
          <div style="font-size:24px;font-weight:700;letter-spacing:2px;text-transform:uppercase">${d.seller.businessName||'Business Name'}</div>
          <div style="font-size:10px;color:#555;letter-spacing:1px">🍁 CRA COMPLIANT CANADA TAX INVOICE</div>
        </div>
      </div>
      <div style="text-align:right">
        <div style="font-size:10px;color:#555;text-transform:uppercase;letter-spacing:1px">Invoice No.</div>
        <div style="font-size:18px;font-weight:700;font-family:monospace">${d.invoicePrefix}-${d.invoiceNum}</div>
        <div style="font-size:11px;color:#555;margin-top:2px">${d.invoiceDate}</div>
        <div style="margin-top:6px">${_statusBadge(d.invoiceStatus)}</div>
      </div>
    </div>
    <div style="display:flex;gap:24px;justify-content:space-between;border-bottom:1px solid #ccc;padding-bottom:12px;margin-bottom:14px;font-size:11px">
      <span>Due: <strong>${d.dueDate}</strong></span><span>Terms: <strong>Net ${d.paymentTerms}</strong></span><span>Currency: <strong>${d.currency}</strong></span>${d.taxProv ? `<span>Tax: <strong>${d.taxProv.name}</strong></span>` : ''}
    </div>
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:20px;margin-bottom:16px">
      <div><div style="background:#000;color:#fff;padding:3px 8px;font-size:10px;letter-spacing:1px;text-transform:uppercase;margin-bottom:6px">Seller Details</div><div style="font-size:11px;color:#111;line-height:1.8">${s.lines}</div></div>
      <div><div style="background:#000;color:#fff;padding:3px 8px;font-size:10px;letter-spacing:1px;text-transform:uppercase;margin-bottom:6px">Buyer Details</div><div style="font-weight:700;font-size:13px;margin-bottom:4px">${d.buyer.businessName||'—'}</div><div style="font-size:11px;color:#111;line-height:1.8">${b.lines}</div></div>
    </div>
    <table style="width:100%;border-collapse:collapse;font-size:12px;margin-bottom:16px">
      <thead><tr style="border-bottom:2px solid #000;border-top:2px solid #000">${['#','Description','Qty','Rate','Tax?','Total'].map(h=>`<th style="padding:7px 8px;text-align:${['Qty','Rate','Tax?','Total'].includes(h)?'right':'left'};font-size:10px;letter-spacing:0.5px;text-transform:uppercase">${h}</th>`).join('')}</tr></thead>
      <tbody>${_itemRows(d)}</tbody>
    </table>
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:20px;margin-bottom:16px">
      <div>
        <div style="font-style:italic;font-size:11px;border:1px solid #ccc;padding:8px;margin-bottom:10px"><strong>In Words:</strong><br>${numberToWords(d.grandTotal)}</div>
        <div style="font-size:10px;color:#555;white-space:pre-line">${d.terms||''}</div>
      </div>
      <div>${_summaryTable(d, '#111827')}</div>
    </div>
    <div style="border-top:2px solid #000;padding-top:14px;display:flex;justify-content:space-between;align-items:flex-end">
      <div style="font-size:10px;color:#777">🍁 CRA Compliant · Excise Tax Act · ${_taxBadge(d) || d.currency}<br>Computer generated — no physical signature required</div>
      ${_signHtml(d.businessSignatureUrl, d.seller.businessName, 180)}
    </div>
  </div>
  </body></html>`;
}

function tplModern(d) {
  const s = _infoBlock(d.seller);
  const b = _infoBlock(d.buyer, true);
  return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Invoice ${d.invoicePrefix}-${d.invoiceNum}</title>
  <style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:system-ui,'Segoe UI',sans-serif;font-size:12px;color:#0f172a;background:#f8fafc;min-height:100vh;padding:24px}.card{background:#fff;max-width:900px;margin:0 auto;border-radius:12px;overflow:hidden;border:1px solid #e2e8f0}@media print{body{background:#fff;padding:0}.card{border-radius:0;border:none}@page{margin:.8cm}}</style></head><body>
  <div class="card">
    <div style="background:#0f172a;padding:26px 32px;display:grid;grid-template-columns:1fr auto;gap:20px;align-items:start">
      <div style="display:flex;align-items:center;gap:16px">
        ${_logoHtml(d.businessLogoUrl, d.seller.businessName, '#374151', 60)}
        <div>
          <div style="font-size:22px;font-weight:700;color:#fff">${d.seller.businessName||'Business Name'}</div>
          <div style="font-size:10px;color:#94a3b8;margin-top:4px;line-height:1.6">${s.lines}</div>
        </div>
      </div>
      <div style="text-align:right">
        <div style="font-size:10px;color:#94a3b8;text-transform:uppercase;letter-spacing:1px">Tax Invoice</div>
        <div style="font-size:20px;font-weight:700;color:#60a5fa;margin:4px 0">${d.invoicePrefix}-${d.invoiceNum}</div>
        <div style="font-size:11px;color:#94a3b8">${d.invoiceDate}</div>
        <div style="margin-top:8px">${_statusBadge(d.invoiceStatus)}</div>
      </div>
    </div>
    <div style="background:#1e293b;padding:7px 32px;display:flex;gap:20px;font-size:11px;color:#94a3b8">
      <span>Due: <strong style="color:#60a5fa">${d.dueDate}</strong></span><span>Terms: <strong style="color:#e2e8f0">Net ${d.paymentTerms}</strong></span><span>Currency: <strong style="color:#e2e8f0">${d.currency}</strong></span>${d.taxProv?`<span>Tax: <strong style="color:#e2e8f0">${d.taxProv.name}</strong></span>`:''}
    </div>
    <div style="padding:24px 32px">
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:20px">
        <div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:14px"><div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;color:#2563eb;margin-bottom:5px">From — Seller</div><div style="font-size:14px;font-weight:700;color:#0f172a">${d.seller.businessName||'—'}</div><div style="font-size:11px;color:#64748b;line-height:1.7;margin-top:3px">${s.lines}</div></div>
        <div style="background:#f0fdf4;border:1px solid #86efac;border-radius:8px;padding:14px"><div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;color:#059669;margin-bottom:5px">To — Buyer</div><div style="font-size:14px;font-weight:700;color:#0f172a">${d.buyer.businessName||'—'}</div><div style="font-size:11px;color:#64748b;line-height:1.7;margin-top:3px">${b.lines}</div></div>
      </div>
      <table style="width:100%;border-collapse:collapse;font-size:13px;margin-bottom:20px">
        <thead><tr style="background:#0f172a">${['#','Description','Qty','Rate','Tax?','Total'].map(h=>`<th style="padding:10px 8px;text-align:${['Qty','Rate','Tax?','Total'].includes(h)?'right':'left'};font-size:10px;font-weight:600;color:#f1f5f9;text-transform:uppercase;letter-spacing:0.5px">${h}</th>`).join('')}</tr></thead>
        <tbody>${_itemRows(d)}</tbody>
      </table>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:20px">
        <div style="background:#fefce8;border:1px solid #fde68a;border-radius:8px;padding:14px"><div style="font-size:10px;font-weight:700;color:#78350f;letter-spacing:1px;margin-bottom:6px">AMOUNT IN WORDS</div><div style="font-size:13px;font-weight:700;color:#111827;line-height:1.5">${numberToWords(d.grandTotal)}</div><div style="margin-top:8px">${_taxBadge(d)}</div></div>
        <div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:14px">${_summaryTable(d, '#2563eb')}</div>
      </div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px">
        <div><div style="font-size:10px;font-weight:700;color:#6b7280;letter-spacing:1px;margin-bottom:6px">TERMS & CONDITIONS</div><div style="font-size:11px;color:#374151;line-height:1.8;white-space:pre-line;background:#f9fafb;border-radius:6px;padding:10px;border:1px solid #e5e7eb">${d.terms||''}</div></div>
        <div style="display:flex;flex-direction:column;align-items:flex-end;justify-content:flex-end">${_signHtml(d.businessSignatureUrl, d.seller.businessName)}</div>
      </div>
    </div>
    <div style="background:#0f172a;padding:10px 32px;display:flex;justify-content:space-between;font-size:10px;color:#64748b">
      <span>🍁 CRA Compliant · GST/HST Ready · Excise Tax Act</span><span>${d.invoicePrefix}-${d.invoiceNum} · ${d.currency}</span>
    </div>
  </div>
  </body></html>`;
}

function tplElegant(d) {
  const s = _infoBlock(d.seller);
  const b = _infoBlock(d.buyer, true);
  return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Invoice ${d.invoicePrefix}-${d.invoiceNum}</title>
  <style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:'Georgia',serif;font-size:12px;color:#1c1a14;padding:0;background:#f5f0e8}.page{max-width:900px;margin:0 auto;background:#fff;border:1px solid #d4a853}.gbar{height:6px;background:linear-gradient(90deg,#92400e,#d97706,#f59e0b,#d97706,#92400e)}@media print{body{background:#fff;padding:0}.page{border:none}@page{margin:.8cm}}</style></head><body>
  <div class="page">
    <div class="gbar"></div>
    <div style="padding:22px 32px;display:flex;justify-content:space-between;align-items:flex-start;border-bottom:1px solid #fde68a">
      <div style="display:flex;align-items:center;gap:16px">
        ${_logoHtml(d.businessLogoUrl, d.seller.businessName, '#d97706', 60)}
        <div>
          <div style="font-size:24px;font-weight:700;color:#78350f">${d.seller.businessName||'Business Name'}</div>
          <div style="font-size:11px;color:#92400e;line-height:1.7;margin-top:4px">${d.seller.address||''}</div>
        </div>
      </div>
      <div style="text-align:right">
        <div style="display:inline-block;background:linear-gradient(135deg,#d97706,#92400e);color:#fff;padding:5px 14px;border-radius:4px;font-size:10px;font-weight:700;letter-spacing:2px;margin-bottom:6px">✦ TAX INVOICE ✦</div>
        <div style="font-size:20px;font-weight:700;color:#78350f">${d.invoicePrefix}-${d.invoiceNum}</div>
        <div style="font-size:11px;color:#92400e;margin-top:2px">${d.invoiceDate}</div>
        <div style="margin-top:8px">${_statusBadge(d.invoiceStatus)}</div>
      </div>
    </div>
    <div style="background:linear-gradient(90deg,#fffbeb,#fef3c7,#fffbeb);padding:6px 32px;display:flex;gap:20px;font-size:11px;color:#78350f;border-bottom:1px solid #fde68a">
      <span>Due: <strong>${d.dueDate}</strong></span><span>Terms: <strong>Net ${d.paymentTerms}</strong></span><span>Currency: <strong>${d.currency}</strong></span>${d.taxProv?`<span>Province: <strong>${d.taxProv.name}</strong></span>`:''}
    </div>
    <div style="padding:20px 32px">
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:18px">
        <div style="padding:12px 14px;border:1px solid #fde68a;background:#fffbeb;border-radius:4px"><div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:1px;color:#d97706;margin-bottom:5px">From — Seller</div><div style="font-size:14px;font-weight:700;color:#78350f">${d.seller.businessName||'—'}</div><div style="font-size:11px;color:#92400e;line-height:1.7;margin-top:3px">${s.lines}</div></div>
        <div style="padding:12px 14px;border:1px solid #fde68a;background:#fffbeb;border-radius:4px"><div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:1px;color:#d97706;margin-bottom:5px">Bill To — Buyer</div><div style="font-size:14px;font-weight:700;color:#78350f">${d.buyer.businessName||'—'}</div><div style="font-size:11px;color:#92400e;line-height:1.7;margin-top:3px">${b.lines}</div></div>
      </div>
      <table style="width:100%;border-collapse:collapse;font-size:13px;margin-bottom:18px">
        <thead><tr style="background:linear-gradient(90deg,#78350f,#92400e)">${['#','Description','Qty','Rate','Tax?','Total'].map(h=>`<th style="padding:9px 8px;text-align:${['Qty','Rate','Tax?','Total'].includes(h)?'right':'left'};font-size:10px;font-weight:700;color:#fef3c7;text-transform:uppercase;letter-spacing:0.5px">${h}</th>`).join('')}</tr></thead>
        <tbody>${_itemRows(d)}</tbody>
      </table>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:18px">
        <div style="background:#fffbeb;border:1px solid #fde68a;border-radius:4px;padding:14px"><div style="font-size:10px;font-weight:700;color:#d97706;letter-spacing:1px;margin-bottom:6px">AMOUNT IN WORDS</div><div style="font-size:13px;font-weight:700;color:#78350f;line-height:1.5">${numberToWords(d.grandTotal)}</div><div style="margin-top:8px">${_taxBadge(d)}</div></div>
        <div style="border:1px solid #fde68a;border-radius:4px;overflow:hidden;padding:14px">${_summaryTable(d, '#d97706')}</div>
      </div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px">
        <div><div style="font-size:10px;font-weight:700;color:#92400e;letter-spacing:1px;margin-bottom:6px">TERMS & CONDITIONS</div><div style="font-size:11px;color:#92400e;line-height:1.8;white-space:pre-line;background:#fffbeb;border-radius:4px;padding:10px;border:1px solid #fde68a">${d.terms||''}</div></div>
        <div style="display:flex;flex-direction:column;align-items:flex-end;justify-content:flex-end">${_signHtml(d.businessSignatureUrl, d.seller.businessName)}</div>
      </div>
    </div>
    <div style="padding:10px 32px;display:flex;justify-content:space-between;font-size:10px;color:#b0956a;border-top:1px solid #fde68a">
      <span>🍁 CRA Compliant · Excise Tax Act · ${d.currency}</span><span>Computer generated invoice</span>
    </div>
    <div class="gbar"></div>
  </div>
  </body></html>`;
}

function tplGov(d) {
  const s = _infoBlock(d.seller);
  const b = _infoBlock(d.buyer, true);
  return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Invoice ${d.invoicePrefix}-${d.invoiceNum}</title>
  <style>*{box-sizing:border-box}body{font-family:Arial,Helvetica,sans-serif;font-size:11px;color:#1a1a1a;padding:20px 28px;max-width:940px;margin:0 auto}.outer{border:1.5px solid #1e293b}@media print{body{padding:10px}@page{margin:.7cm}}</style></head><body>
  <div style="height:6px;background:#c41e3a;margin-bottom:0"></div>
  <div class="outer">
    <div style="padding:12px 18px 10px;border-bottom:1px solid #e2e8f0;display:flex;justify-content:space-between;align-items:flex-start">
      <div style="display:flex;align-items:center;gap:12px">
        ${_logoHtml(d.businessLogoUrl, d.seller.businessName, '#1e293b', 56)}
        <div>
          <div style="font-size:22px;font-weight:900;color:#1e293b;letter-spacing:1px;text-transform:uppercase">${d.seller.businessName||'Company Name'}</div>
          <div style="background:#1e293b;color:#fff;font-size:10px;font-weight:700;display:inline-block;padding:3px 8px;margin-top:4px">🍁 CRA Compliant Tax Invoice · ${d.currency}</div>
          <div style="font-size:11px;color:#374151;line-height:1.7;margin-top:4px">${s.lines}</div>
        </div>
      </div>
      <div style="text-align:right">
        <div style="font-size:10px;font-weight:700;color:#555;text-transform:uppercase;letter-spacing:1px">ORIGINAL FOR RECIPIENT</div>
        <div style="font-size:18px;font-weight:700;font-family:monospace;color:#1e293b;margin:4px 0">${d.invoicePrefix}-${d.invoiceNum}</div>
        <div style="font-size:11px;color:#374151">Date: <strong>${d.invoiceDate}</strong></div>
        <div style="font-size:11px;color:#374151">Due: <strong style="color:#dc2626">${d.dueDate}</strong></div>
        <div style="margin-top:8px">${_statusBadge(d.invoiceStatus)}</div>
      </div>
    </div>
    <div style="display:flex;border-bottom:1px solid #e2e8f0">
      <div style="flex:1;padding:8px 18px;border-right:1px solid #e2e8f0"><div style="font-size:10px;font-weight:700;text-transform:uppercase;color:#0d9488;margin-bottom:4px">Customer Details</div><div style="font-size:13px;font-weight:700">${d.buyer.businessName||'—'}</div><div style="font-size:11px;color:#374151;line-height:1.7;margin-top:3px">${b.lines}</div></div>
      <div style="flex:1;padding:8px 18px"><div style="font-size:10px;font-weight:700;text-transform:uppercase;color:#0d9488;margin-bottom:4px">Invoice Details</div><div style="font-size:11px;color:#374151;line-height:2">Terms: <strong>Net ${d.paymentTerms}</strong><br>${d.taxProv?`Province: <strong>${d.taxProv.name}</strong><br>`:''} ${_taxBadge(d)}<br>Currency: <strong>${d.currency}</strong></div></div>
    </div>
    <table style="width:100%;border-collapse:collapse;font-size:11px">
      <thead><tr style="background:#f1f5f9;border-bottom:2px solid #1e293b;border-top:2px solid #1e293b">${['#','Description','Qty','Rate','Tax?','Total'].map((h,i)=>`<th style="padding:8px;text-align:${i>1?'right':'left'};font-size:10px;font-weight:700;color:#1e293b;text-transform:uppercase;letter-spacing:0.3px">${h}</th>`).join('')}</tr></thead>
      <tbody>${_itemRows(d)}</tbody>
    </table>
    <div style="display:grid;grid-template-columns:1fr 1fr;border-top:1.5px solid #1e293b">
      <div style="padding:12px 18px;border-right:1px solid #e2e8f0"><div style="font-weight:700;margin-bottom:5px;font-size:11px">Total in words:</div><div style="font-style:italic;font-size:11px;color:#374151">${numberToWords(d.grandTotal)}</div><div style="margin-top:10px;font-size:10px;color:#64748b;white-space:pre-line">${d.terms||''}</div></div>
      <div style="padding:10px 18px">${_summaryTable(d, '#1e293b')}</div>
    </div>
    <div style="display:flex;justify-content:space-between;align-items:flex-end;padding:10px 18px;border-top:1px solid #e2e8f0">
      ${_signHtml(d.businessSignatureUrl, d.seller.businessName, 160)}
      <div style="font-size:10px;color:#94a3b8;text-align:right">Computer generated invoice<br>GST/HST Compliant · Sec. 169 Excise Tax Act</div>
    </div>
  </div>
  <div style="height:6px;background:#c41e3a;margin-top:0"></div>
  </body></html>`;
}

function tplMinimal(d) {
  const s = _infoBlock(d.seller);
  const b = _infoBlock(d.buyer, true);
  return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Invoice ${d.invoicePrefix}-${d.invoiceNum}</title>
  <style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:system-ui,-apple-system,sans-serif;font-size:12px;color:#1a1a1a;padding:32px 40px;max-width:860px;margin:0 auto}hr{border:none;border-top:1px solid #e2e8f0;margin:16px 0}@media print{body{padding:20px}@page{margin:1cm}}</style></head><body>
  <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:20px">
    <div style="display:flex;align-items:center;gap:14px">
      ${_logoHtml(d.businessLogoUrl, d.seller.businessName, '#1e293b', 56)}
      <div><div style="font-size:22px;font-weight:700;color:#111827">${d.seller.businessName||'Business Name'}</div><div style="font-size:10px;color:#6b7280;margin-top:2px">🍁 Canada Tax Invoice · CRA Compliant</div></div>
    </div>
    <div style="text-align:right"><div style="font-size:10px;color:#94a3b8;text-transform:uppercase;letter-spacing:.5px">Invoice</div><div style="font-size:20px;font-weight:700;font-family:monospace;color:#111827">${d.invoicePrefix}-${d.invoiceNum}</div><div style="font-size:11px;color:#6b7280;margin-top:2px">${d.invoiceDate}</div><div style="margin-top:6px">${_statusBadge(d.invoiceStatus)}</div></div>
  </div>
  <div style="font-size:11px;color:#374151;line-height:1.8;margin-bottom:16px">${s.lines}</div>
  <hr>
  <div style="display:grid;grid-template-columns:1fr 1fr;gap:20px;margin-bottom:16px">
    <div><div style="font-size:10px;color:#94a3b8;text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px">Bill To</div><div style="font-size:14px;font-weight:600;color:#111827">${d.buyer.businessName||'—'}</div><div style="font-size:11px;color:#475569;line-height:1.8;margin-top:3px">${b.lines}</div></div>
    <div><div style="font-size:10px;color:#94a3b8;text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px">Details</div><div style="font-size:11px;color:#374151;line-height:2">Due Date: <strong>${d.dueDate}</strong><br>Terms: <strong>Net ${d.paymentTerms}</strong><br>Currency: <strong>${d.currency}</strong><br>${_taxBadge(d)}</div></div>
  </div>
  <table style="width:100%;border-collapse:collapse;font-size:12px;margin-bottom:16px">
    <thead><tr style="border-bottom:2px solid #111827">${['#','Description','Qty','Rate','Tax?','Total'].map(h=>`<th style="padding:7px 8px;text-align:${['Qty','Rate','Tax?','Total'].includes(h)?'right':'left'};font-size:10px;text-transform:uppercase;letter-spacing:.5px;color:#64748b">${h}</th>`).join('')}</tr></thead>
    <tbody>${_itemRows(d)}</tbody>
  </table>
  <div style="display:grid;grid-template-columns:1fr 1fr;gap:20px;margin-bottom:16px">
    <div><div style="font-style:italic;font-size:11px;color:#475569;padding:10px;background:#f8fafc;border-radius:6px;margin-bottom:10px"><strong>In Words:</strong><br>${numberToWords(d.grandTotal)}</div><div style="font-size:10px;color:#64748b;white-space:pre-line">${d.terms||''}</div></div>
    <div>${_summaryTable(d,'#111827')}</div>
  </div>
  <hr>
  <div style="display:flex;justify-content:space-between;align-items:flex-end">
    <div style="font-size:10px;color:#94a3b8">🍁 CRA Compliant · GST/HST Ready · ${d.currency}<br>Computer generated — no physical signature required</div>
    ${_signHtml(d.businessSignatureUrl, d.seller.businessName, 180)}
  </div>
  </body></html>`;
}

function tplTeal(d) {
  const s = _infoBlock(d.seller);
  const b = _infoBlock(d.buyer, true);
  return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Invoice ${d.invoicePrefix}-${d.invoiceNum}</title>
  <style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:Arial,sans-serif;font-size:12px;color:#134e4a;max-width:900px;margin:0 auto}@media print{@page{margin:.8cm}}</style></head><body>
  <div style="background:linear-gradient(135deg,#0f766e,#0d9488);padding:24px 30px;display:flex;justify-content:space-between;align-items:flex-start">
    <div style="display:flex;align-items:center;gap:16px">
      ${_logoHtml(d.businessLogoUrl, d.seller.businessName, '#0f766e', 60)}
      <div><div style="font-size:22px;font-weight:700;color:#fff">${d.seller.businessName||'Business Name'}</div><div style="font-size:10px;color:#99f6e4;margin-top:4px;line-height:1.6">${s.lines}</div></div>
    </div>
    <div style="text-align:right"><div style="font-size:10px;color:#5eead4;text-transform:uppercase;letter-spacing:1px">Tax Invoice</div><div style="font-size:20px;font-weight:700;color:#fff;margin:4px 0">${d.invoicePrefix}-${d.invoiceNum}</div><div style="font-size:11px;color:#99f6e4">${d.invoiceDate}</div><div style="margin-top:8px">${_statusBadge(d.invoiceStatus)}</div></div>
  </div>
  <div style="background:#134e4a;color:#5eead4;padding:7px 30px;display:flex;gap:20px;font-size:11px">
    <span>Due: <strong style="color:#fff">${d.dueDate}</strong></span><span>Terms: <strong style="color:#fff">Net ${d.paymentTerms}</strong></span><span>Currency: <strong style="color:#fff">${d.currency}</strong></span>${d.taxProv?`<span>Province: <strong style="color:#fff">${d.taxProv.name}</strong></span>`:''}
  </div>
  <div style="padding:20px 30px">
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:18px">
      <div style="background:#f0fdf4;border-left:3px solid #0d9488;border-radius:0 6px 6px 0;padding:12px 14px"><div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;color:#0d9488;margin-bottom:4px">Seller</div><div style="font-size:14px;font-weight:700;color:#134e4a">${d.seller.businessName||'—'}</div><div style="font-size:11px;color:#475569;line-height:1.7;margin-top:3px">${s.lines}</div></div>
      <div style="background:#f0fdf4;border-left:3px solid #0d9488;border-radius:0 6px 6px 0;padding:12px 14px"><div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;color:#0d9488;margin-bottom:4px">Bill To</div><div style="font-size:14px;font-weight:700;color:#134e4a">${d.seller.businessName||'—'}</div><div style="font-size:11px;color:#475569;line-height:1.7;margin-top:3px">${b.lines}</div></div>
    </div>
    <table style="width:100%;border-collapse:collapse;font-size:13px;margin-bottom:18px">
      <thead><tr style="background:#0d9488">${['#','Description','Qty','Rate','Tax?','Total'].map(h=>`<th style="padding:9px 8px;text-align:${['Qty','Rate','Tax?','Total'].includes(h)?'right':'left'};font-size:10px;font-weight:700;color:#fff;text-transform:uppercase;letter-spacing:.3px">${h}</th>`).join('')}</tr></thead>
      <tbody>${_itemRows(d)}</tbody>
    </table>
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:18px">
      <div style="background:#f0fdf4;border:1px solid #99f6e4;border-radius:6px;padding:14px"><div style="font-size:10px;font-weight:700;color:#0d9488;letter-spacing:1px;margin-bottom:6px">AMOUNT IN WORDS</div><div style="font-size:13px;font-weight:700;color:#134e4a;line-height:1.5">${numberToWords(d.grandTotal)}</div><div style="margin-top:8px">${_taxBadge(d)}</div></div>
      <div style="background:#f0fdf4;border:1px solid #99f6e4;border-radius:6px;padding:14px">${_summaryTable(d, '#0d9488')}</div>
    </div>
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px">
      <div><div style="font-size:10px;font-weight:700;color:#64748b;letter-spacing:1px;margin-bottom:6px">TERMS & CONDITIONS</div><div style="font-size:11px;color:#374151;line-height:1.8;white-space:pre-line;background:#f0fdf4;border-radius:6px;padding:10px;border:1px solid #ccfbf1">${d.terms||''}</div></div>
      <div style="display:flex;flex-direction:column;align-items:flex-end;justify-content:flex-end">${_signHtml(d.businessSignatureUrl, d.seller.businessName)}</div>
    </div>
  </div>
  <div style="background:#f0fdf4;border-top:2px solid #0d9488;padding:10px 30px;display:flex;justify-content:space-between;font-size:10px;color:#94a3b8">
    <span>🍁 CRA Compliant · GST/HST Ready · Excise Tax Act</span><span>${d.invoicePrefix}-${d.invoiceNum} · ${d.currency}</span>
  </div>
  </body></html>`;
}

const TEMPLATE_MAP = {
  maple: tplMaple, arctic: tplArctic, formal: tplFormal, modern: tplModern,
  elegant: tplElegant, gov: tplGov, minimal: tplMinimal, teal: tplTeal,
};

function generateCanadaInvoicePDF(templateId, invoiceData) {
  const render = TEMPLATE_MAP[templateId] || tplMaple;
  const filename = `Invoice_${invoiceData.invoicePrefix}-${invoiceData.invoiceNum}_${(invoiceData.buyer?.businessName || 'Client').replace(/\s+/g,'_')}.pdf`;
  _openPrint(render(invoiceData), filename);
}

// ============================================================
// SHARED HELPERS
// ============================================================
const DEFAULT_TERMS = `1. Payment is due within 30 days from invoice date.
2. Late payments will be charged 1.5% interest per month.
3. All prices are in Canadian Dollars (CAD) unless stated otherwise.
4. This invoice is subject to the laws of the Province indicated.`;

const createEmptyItem = () => ({
  id: Date.now() + Math.random(),
  description: "",
  qty: 1,
  rate: "",
  taxable: true,
  product_id: "", 
});

const fmt = (n) =>
  Number(n).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const fmtCurrency = (n, currency = "CAD") =>
  `${currency === "CAD" ? "CA$" : "US$"} ${fmt(n)}`;

// Look up a product's currently available stock quantity by its product_id
const getAvailableStock = (products, productId) => {
  if (!productId) return null;
  const p = products.find((pr) => String(pr.id) === String(productId));
  return p ? parseInt(p.quantity, 10) || 0 : null;
};

const addDays = (dateStr, days) => {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};

const emptyParty = () => ({
  businessName: "", address: "", city: "", province: "",
  postalCode: "", country: "Canada", phone: "", email: "", taxNumber: "",
  footerNote: "",
});

const STATUS_CONFIG = {
  DRAFT:  { label: "📝 DRAFT",  borderColor: "#2563eb", color: "#2563eb", bg: "#eff6ff" },
  UNPAID: { label: "🔴 UNPAID", borderColor: "#ef4444", color: "#dc2626", bg: "#fff1f2" },
  PAID:   { label: "✅ PAID",   borderColor: "#22c55e", color: "#15803d", bg: "#f0fdf4" },
};

const FieldLabel = ({ children, required = false }) => (
  <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 5, fontWeight: 500 }}>
    {children}{required && <span style={{ color: "#ef4444", marginLeft: 2 }}>*</span>}
  </div>
);

const TextInput = ({ style = {}, ...props }) => (
  <input
    style={{
      width: "100%", padding: "9px 12px", border: "1px solid #e5e7eb",
      borderRadius: 8, fontSize: 13, color: "#111827", background: "#fff",
      outline: "none", boxSizing: "border-box", fontFamily: "inherit",
      transition: "border-color .15s", ...style,
    }}
    onFocus={(e) => (e.target.style.borderColor = "#2563eb")}
    onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
    {...props}
  />
);

const SelectInput = ({ children, style = {}, ...props }) => (
  <select
    style={{
      width: "100%", padding: "9px 12px", border: "1px solid #e5e7eb",
      borderRadius: 8, fontSize: 13, color: "#111827", background: "#fff",
      outline: "none", boxSizing: "border-box", fontFamily: "inherit", cursor: "pointer", ...style,
    }}
    {...props}
  >
    {children}
  </select>
);

const Card = ({ children, style = {} }) => (
  <div style={{
    background: "#fff", border: "1px solid #e5e7eb",
    borderRadius: 12, padding: "24px", marginBottom: 20, ...style,
  }}>
    {children}
  </div>
);

const TaxBadge = ({ province }) => {
  if (!province) return null;
  const color  = province.taxType === "HST" ? "#7c3aed" : "#2563eb";
  const bg     = province.taxType === "HST" ? "#f5f3ff" : "#eff6ff";
  const border = province.taxType === "HST" ? "#e9d5ff" : "#bfdbfe";
  const parts  = [];
  if (province.hst > 0) parts.push(`HST ${province.hst}%`);
  if (province.gst > 0) parts.push(`GST ${province.gst}%`);
  if (province.pst > 0) parts.push(`PST ${province.pst}%`);
  if (province.qst > 0) parts.push(`QST ${province.qst}%`);
  return (
    <div style={{
      padding: "9px 14px", borderRadius: 8, fontSize: 13, fontWeight: 600,
      background: bg, border: `1px solid ${border}`, color,
      display: "flex", alignItems: "center", gap: 8,
    }}>
      <span>🍁</span>
      <span>{province.name} — {parts.join(" + ")}</span>
    </div>
  );
};

const AuthBanner = ({ message }) => (
  <div style={{
    padding: "14px 20px", background: "#fff1f2", border: "1.5px solid #fecaca",
    borderRadius: 10, marginBottom: 20, display: "flex", alignItems: "center", gap: 12,
  }}>
    <span style={{ fontSize: 20 }}>🔒</span>
    <div>
      <div style={{ fontSize: 13, fontWeight: 700, color: "#dc2626" }}>Authentication Required</div>
      <div style={{ fontSize: 12, color: "#7f1d1d", marginTop: 2 }}>{message}</div>
    </div>
  </div>
);

const BuyerNameDropdown = ({ clients, loading, error, selectedId, value, onSelect, onChange }) => {
  const [open, setOpen]   = useState(false);
  const [query, setQuery] = useState("");
  const wrapRef           = useRef(null);
  const inputRef          = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
        setQuery("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const selected = clients.find((c) => String(c.id) === String(selectedId));
  const filtered = clients.filter((c) => {
    if (!query) return true;
    const q = query.toLowerCase();
    return (
      c.client_name?.toLowerCase().includes(q) ||
      c.email?.toLowerCase().includes(q) ||
      c.city?.toLowerCase().includes(q) ||
      c.mobile?.includes(q)
    );
  });

  const handleInputChange = (e) => { const val = e.target.value; setQuery(val); onChange(val); setOpen(true); };
  const handleSelect = (client) => { onSelect(String(client.id)); setQuery(""); setOpen(false); inputRef.current?.blur(); };
  const handleClear = (e) => { e && e.stopPropagation(); onSelect(""); onChange(""); setQuery(""); setOpen(false); };
  const displayValue = selected ? selected.client_name : value;

  return (
    <div ref={wrapRef}>
      <FieldLabel required>Business / Client Name</FieldLabel>
      <div style={{ position: "relative" }}>
        <input
          ref={inputRef}
          value={open ? query : displayValue}
          onChange={handleInputChange}
          onFocus={() => { setQuery(""); setOpen(true); }}
          placeholder={loading ? "Loading clients..." : "Type to search or click to open list..."}
          disabled={loading}
          style={{
            width: "100%", padding: "9px 70px 9px 12px",
            border: `1.5px solid ${selected ? "#22c55e" : open ? "#2563eb" : "#e5e7eb"}`,
            borderRadius: 8, fontSize: 13, color: "#111827",
            background: selected ? "#f0fdf4" : "#fff",
            outline: "none", boxSizing: "border-box", fontFamily: "inherit",
            transition: "border-color .15s, background .15s",
            cursor: loading ? "not-allowed" : "text",
          }}
        />
        <div style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", gap: 6 }}>
          {selected && (<span onClick={handleClear} title="Clear" style={{ width: 18, height: 18, borderRadius: "50%", background: "#fecaca", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, color: "#dc2626", cursor: "pointer", fontWeight: 700, flexShrink: 0 }}>×</span>)}
          {selected ? <span style={{ fontSize: 14, color: "#22c55e" }}>✓</span> : <span style={{ fontSize: 10, color: "#9ca3af", transform: open ? "rotate(180deg)" : "none", transition: "transform .2s", cursor: "pointer" }} onClick={() => setOpen((o) => !o)}>▼</span>}
        </div>
        {open && (
          <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, zIndex: 1000, background: "#fff", border: "1.5px solid #2563eb", borderRadius: 10, boxShadow: "0 10px 28px rgba(0,0,0,0.13)", overflow: "hidden" }}>
            <div style={{ padding: "8px 14px", background: "#eff6ff", borderBottom: "1px solid #dbeafe", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span style={{ fontSize: 11, fontWeight: 700, color: "#2563eb", letterSpacing: 0.5 }}>{query ? `"${query}" — ${filtered.length} result${filtered.length !== 1 ? "s" : ""}` : `${clients.length} clients`}</span>
              {query && (<span onClick={() => { setQuery(""); onChange(""); }} style={{ fontSize: 11, color: "#6b7280", cursor: "pointer", textDecoration: "underline" }}>Clear</span>)}
            </div>
            <div style={{ maxHeight: 260, overflowY: "auto" }}>
              {error && (<div style={{ padding: "12px 14px", fontSize: 12, color: "#dc2626", background: "#fff1f2" }}>⚠️ {error}</div>)}
              {!error && filtered.length === 0 && (<div style={{ padding: "20px 14px", textAlign: "center", color: "#6b7280", fontSize: 13 }}>😕 No client found for "{query}"</div>)}
              {!error && filtered.map((c) => {
                const isActive = String(c.id) === String(selectedId);
                const initials = (c.client_name || "?").slice(0, 2).toUpperCase();
                return (
                  <div key={c.id} onClick={() => handleSelect(c)} style={{ padding: "11px 14px", cursor: "pointer", background: isActive ? "#eff6ff" : "transparent", borderBottom: "1px solid #f9fafb", display: "flex", alignItems: "center", gap: 10, transition: "background .1s" }} onMouseEnter={(e) => { if (!isActive) e.currentTarget.style.background = "#f9fafb"; }} onMouseLeave={(e) => { if (!isActive) e.currentTarget.style.background = isActive ? "#eff6ff" : "transparent"; }}>
                    <div style={{ width: 34, height: 34, borderRadius: "50%", flexShrink: 0, background: isActive ? "#2563eb" : "#e5e7eb", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700, color: isActive ? "#fff" : "#6b7280" }}>{initials}</div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 600, fontSize: 13, color: "#111827", display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                        {c.client_name}
                        {c.status && (<span style={{ fontSize: 10, padding: "1px 6px", borderRadius: 4, fontWeight: 700, background: c.status === "Active" ? "#dcfce7" : "#f3f4f6", color: c.status === "Active" ? "#059669" : "#6b7280" }}>{c.status}</span>)}
                      </div>
                      <div style={{ fontSize: 11, color: "#6b7280", marginTop: 2, display: "flex", gap: 10, flexWrap: "wrap" }}>
                        {c.email && <span>✉ {c.email}</span>}
                        {c.city && c.province && <span>📍 {c.city}, {c.province}</span>}
                        {c.mobile && <span>📞 {c.mobile}</span>}
                      </div>
                    </div>
                    {isActive && <span style={{ color: "#2563eb", fontSize: 16, flexShrink: 0 }}>✓</span>}
                  </div>
                );
              })}
            </div>
            <div style={{ padding: "7px 14px", borderTop: "1px solid #f3f4f6", fontSize: 11, color: "#9ca3af", background: "#fafafa", display: "flex", justifyContent: "space-between" }}>
              <span>Select a client to auto-fill all fields</span>
              <span style={{ cursor: "pointer", color: "#6b7280" }} onClick={() => setOpen(false)}>✕ Close</span>
            </div>
          </div>
        )}
      </div>
      {selected && (
        <div style={{ marginTop: 5, padding: "4px 10px", background: "#f0fdf4", border: "1px solid #86efac", borderRadius: 6, fontSize: 11, color: "#065f46", fontWeight: 600, display: "flex", alignItems: "center", gap: 5 }}>
          ✓ {selected.client_name} — All fields auto-filled. You can edit manually.
        </div>
      )}
    </div>
  );
};

const ProductPicker = ({ products, loading, value, onPick, onManualChange }) => {
  const [open, setOpen]   = useState(false);
  const [query, setQuery] = useState("");
  const wrapRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) { setOpen(false); setQuery(""); }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const filtered = products.filter((p) => {
    if (!query) return true;
    const q = query.toLowerCase();
    return p.product_name?.toLowerCase().includes(q) || p.sku?.toLowerCase().includes(q);
  });

  return (
    <div ref={wrapRef} style={{ position: "relative" }}>
      <input
        value={open ? query : value}
        onChange={(e) => { setQuery(e.target.value); onManualChange(e.target.value); setOpen(true); }}
        onFocus={() => { setQuery(""); setOpen(true); }}
        placeholder={loading ? "Loading..." : "Type or pick a product"}
        style={{
          width: "100%", padding: "9px 12px", border: "1px solid #e5e7eb",
          borderRadius: 8, fontSize: 13, outline: "none", boxSizing: "border-box", fontFamily: "inherit",
        }}
      />
      {open && filtered.length > 0 && (
        <div style={{
          position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, zIndex: 1000,
          background: "#fff", border: "1.5px solid #2563eb", borderRadius: 10,
          boxShadow: "0 10px 28px rgba(0,0,0,0.13)", maxHeight: 240, overflowY: "auto",
        }}>
          {filtered.map((p) => {
            const low = parseInt(p.quantity) <= parseInt(p.low_stock_alert);
            return (
              <div
                key={p.id}
                onClick={() => { onPick(p); setOpen(false); setQuery(""); }}
                style={{ padding: "9px 12px", cursor: "pointer", borderBottom: "1px solid #f3f4f6", display: "flex", justifyContent: "space-between", alignItems: "center" }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#f9fafb")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
              >
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "#111827" }}>{p.product_name}</div>
                  <div style={{ fontSize: 11, color: "#6b7280" }}>
                    {p.sku ? `${p.sku} · ` : ""}CA$ {parseFloat(p.selling_price || 0).toFixed(2)}
                  </div>
                </div>
                <span style={{
                  fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 20,
                  background: low ? "#fff0ee" : "#eafaf0", color: low ? "#e0503e" : "#1d9a5b",
                }}>
                  {low && "⚠ "}{p.quantity} {p.unit}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

async function fetchAndSetNextNumber(apiBaseUrl, invoicePrefix, getAuthHeaders, setInvoiceNum, setInvoiceNumLoading) {
  const headers = getAuthHeaders();
  if (!headers) return;
  setInvoiceNumLoading(true);
  try {
    const res = await fetch(`${apiBaseUrl}/api/invoices/next-number?prefix=${invoicePrefix}`, { headers });
    if (!res.ok) return;
    const contentType = res.headers.get("content-type");
    if (!contentType?.includes("application/json")) return;
    const data = await res.json();
    if (data.next_number) {
      setInvoiceNum(String(data.next_number).padStart(3, "0"));
    } else if (data.invoice_number) {
      const parts = String(data.invoice_number).split("-");
      setInvoiceNum(parts[parts.length - 1]);
    }
  } catch (_) {}
  finally { setInvoiceNumLoading(false); }
}

// ============================================================
// MAIN COMPONENT
// ============================================================
export default function CanadaInvoiceGenerator({
  token,
  initialItems,
  invoicePrefix: prefixProp = "INV",
  currency = "CAD",
  apiBaseUrl = "https://canada-billing.ameontech.com",
  editInvoice,
  onSave,
  onCancel,
}) {
  const getInitialInvoiceNum = () => {
    if (editInvoice?.invoice_number) {
      const parts = String(editInvoice.invoice_number).split("-");
      return parts[parts.length - 1];
    }
    return "";
  };

  const [invoicePrefix, setInvoicePrefix] = useState(
    editInvoice?.invoice_prefix || prefixProp
  );
  const [invoiceNum, setInvoiceNum]       = useState(getInitialInvoiceNum);
  const [invoiceNumLoading, setInvoiceNumLoading] = useState(false);
  const [invoiceDate, setInvoiceDate]     = useState(
    editInvoice?.invoice_date ? String(editInvoice.invoice_date).slice(0, 10) : new Date().toISOString().slice(0, 10)
  );
  const [paymentTerms, setPaymentTerms]   = useState(
    editInvoice?.payment_terms ? parseInt(String(editInvoice.payment_terms).replace(/\D/g, "")) || 30 : 30
  );
  const [invoiceStatus, setInvoiceStatus] = useState(
    editInvoice?.status === "Paid" ? "PAID" : editInvoice?.status === "Unpaid" ? "UNPAID" : "DRAFT"
  );
  const [seller, setSeller] = useState(() => editInvoice ? {
    businessName: editInvoice.seller_business_name || "",
    address:      editInvoice.seller_address || "",
    city:         editInvoice.seller_city || "",
    province:     editInvoice.seller_province || "",
    postalCode:   editInvoice.seller_postal_code || "",
    country:      editInvoice.seller_country || "Canada",
    phone:        editInvoice.seller_phone || "",
    email:        editInvoice.seller_email || "",
    taxNumber:    editInvoice.hst_registration_number || "",
    footerNote:   editInvoice.footer_note || "",
  } : emptyParty());

  const [buyer, setBuyer] = useState(() => editInvoice ? {
    businessName: editInvoice.buyer_business_name || "",
    address:      editInvoice.buyer_address || "",
    city:         editInvoice.buyer_city || "",
    province:     editInvoice.buyer_province || "",
    postalCode:   editInvoice.buyer_postal_code || "",
    country:      editInvoice.buyer_country || "Canada",
    phone:        editInvoice.buyer_phone || "",
    email:        editInvoice.buyer_email || "",
    taxNumber:    editInvoice.buyer_tax_number || "",
    footerNote:   "",
  } : emptyParty());

  const [items, setItems] = useState(() => {
    if (editInvoice?.items?.length) {
      return editInvoice.items.map((it, i) => ({
        id: i + 1,
        description: it.description || "",
        qty: it.qty ?? 1,
        rate: it.rate ?? "",
        taxable: it.taxable !== false,
        product_id: it.product_id || "",
      }));
    }
    if (initialItems?.length) {
      return initialItems.map((it, i) => ({ ...it, id: i + 1 }));
    }
    return [createEmptyItem()];
  });

  const [terms, setTerms]   = useState(editInvoice?.terms || DEFAULT_TERMS);
  const [notes, setNotes]   = useState(editInvoice?.notes || "");
  const [businessLogoUrl,      setBusinessLogoUrl]      = useState("");
  const [businessSignatureUrl, setBusinessSignatureUrl] = useState("");
  const [paymentMethod,  setPaymentMethod]  = useState(editInvoice?.payment_method  || "e-Transfer");
  const [paymentDetails, setPaymentDetails] = useState(editInvoice?.payment_details || "");
  
  const [clients, setClients]                   = useState([]);
  const [clientsLoading, setClientsLoading]     = useState(false);
  const [clientsError, setClientsError]         = useState("");
  
  const [products, setProducts]                 = useState([]);
  const [productsLoading, setProductsLoading]   = useState(false);
  const [productsError, setProductsError]       = useState("");

  const [selectedClientId, setSelectedClientId] = useState(
    editInvoice?.client_id ? String(editInvoice.client_id) : ""
  );
  const [profileLoading, setProfileLoading] = useState(false);
  const [profileError,   setProfileError]   = useState("");
  const [saving,      setSaving]      = useState(false);
  const [saveError,   setSaveError]   = useState("");
  const [saveSuccess, setSaveSuccess] = useState(false);

  const [downloadReady, setDownloadReady] = useState(!!editInvoice);
  const [savedInvoiceData, setSavedInvoiceData] = useState(
    editInvoice ? { savedInvoice: editInvoice } : null
  );
  const [showTemplateSelector, setShowTemplateSelector] = useState(false);

  const getAuthHeaders = () => {
    const t = token
      || (typeof localStorage !== "undefined" && localStorage.getItem("token"))
      || (typeof sessionStorage !== "undefined" && sessionStorage.getItem("token"));
    if (!t) return null;
    return { "Content-Type": "application/json", "Authorization": `Bearer ${t}` };
  };

  useEffect(() => {
    if (editInvoice) return;
    const fetchProfile = async () => {
      const headers = getAuthHeaders();
      if (!headers) { setProfileError("No auth token found. Please log in to load your business profile."); return; }
      setProfileLoading(true); setProfileError("");
      try {
        const res = await fetch(`${apiBaseUrl}/api/business-profile`, { headers });
        if (res.status === 401) { setProfileError("Session expired. Please log in again."); return; }
        if (!res.ok) { setProfileError(`Failed to load business profile (${res.status})`); return; }
        const contentType = res.headers.get("content-type");
        if (!contentType?.includes("application/json")) { setProfileError("Server returned unexpected response. Is backend running?"); return; }
        const data = await res.json();
        if (data.profile) {
          const p = data.profile;
          setSeller({ businessName: p.business_name || "", address: p.address_line1 || "", city: p.city || "", province: p.province || "", postalCode: p.postal_code || "", country: p.country || "Canada", phone: p.phone || "", email: p.email || "", taxNumber: p.hst_number || "", footerNote: p.footer_note || "" });
          if (p.invoice_prefix) setInvoicePrefix(p.invoice_prefix);
          if (p.due_days) setPaymentTerms(p.due_days);
          if (p.terms) setTerms(p.terms);
          if (p.footer_note && !notes) setNotes(p.footer_note);
          if (p.logo_url) setBusinessLogoUrl(`${apiBaseUrl}${p.logo_url}`);
          if (p.signature_url) setBusinessSignatureUrl(`${apiBaseUrl}${p.signature_url}`);
        }
      } catch (err) { setProfileError(`Network error: ${err.message}`); }
      finally { setProfileLoading(false); }
    };
    fetchProfile();
  }, [apiBaseUrl, token]);

  useEffect(() => {
    if (editInvoice) return;
    fetchAndSetNextNumber(apiBaseUrl, invoicePrefix, getAuthHeaders, setInvoiceNum, setInvoiceNumLoading);
  }, [apiBaseUrl, token, invoicePrefix]);

  useEffect(() => {
    const fetchClients = async () => {
      const headers = getAuthHeaders();
      if (!headers) { setClientsError("No auth token found. Please log in to load clients."); return; }
      setClientsLoading(true); setClientsError("");
      try {
        const res = await fetch(`${apiBaseUrl}/api/clients`, { headers });
        if (res.status === 401) { setClientsError("Session expired. Please log in again."); return; }
        if (!res.ok) { setClientsError(`Failed to load clients (${res.status})`); return; }
        const contentType = res.headers.get("content-type");
        if (!contentType?.includes("application/json")) { setClientsError(`Server returned non-JSON. Is backend running on ${apiBaseUrl}?`); return; }
        const data = await res.json();
        setClients(data.clients || []);
      } catch (err) { setClientsError(`Network error: ${err.message}`); }
      finally { setClientsLoading(false); }
    };
    fetchClients();
  }, [apiBaseUrl, token]);

  useEffect(() => {
    const fetchProducts = async () => {
      const headers = getAuthHeaders();
      if (!headers) { setProductsError("No auth token found."); return; }
      setProductsLoading(true); setProductsError("");
      try {
        const res = await fetch(`${apiBaseUrl}/api/products`, { headers });
        if (res.status === 401) { setProductsError("Session expired. Please log in again."); return; }
        if (!res.ok) { setProductsError(`Failed to load products (${res.status})`); return; }
        const contentType = res.headers.get("content-type");
        if (!contentType?.includes("application/json")) { setProductsError("Server returned non-JSON."); return; }
        const data = await res.json();
        setProducts(data.products || []);
      } catch (err) { setProductsError(`Network error: ${err.message}`); }
      finally { setProductsLoading(false); }
    };
    fetchProducts();
  }, [apiBaseUrl, token]);

  const handleClientSelect = (clientId) => {
    setSelectedClientId(clientId);
    if (!clientId) { setBuyer(emptyParty()); return; }
    const client = clients.find((c) => String(c.id) === String(clientId));
    if (!client) return;
    const useBilling = client.billing_address_same_as_primary === false && (client.billing_address_line1 || client.billing_city);
    setBuyer({ businessName: client.client_name || "", address: useBilling ? (client.billing_address_line1 || "") : (client.address_line1 || ""), city: useBilling ? (client.billing_city || "") : (client.city || ""), province: useBilling ? (client.billing_province || "") : (client.province || ""), postalCode: useBilling ? (client.billing_postal_code || "") : (client.postal_code || ""), country: useBilling ? (client.billing_country || "Canada") : (client.country || "Canada"), phone: client.mobile || "", email: client.email || "", taxNumber: client.gst_number || "" });
  };

  const updateItem = (id, key, value) => setItems((prev) => prev.map((it) => (it.id === id ? { ...it, [key]: value } : it)));
  const removeItem = (id) => setItems((prev) => (prev.length > 1 ? prev.filter((it) => it.id !== id) : prev));

  const sellerProv      = CANADA_PROVINCES.find((p) => p.code === seller.province);
  const buyerProv       = CANADA_PROVINCES.find((p) => p.code === buyer.province);
  const taxProv         = buyerProv ?? sellerProv;
  const subtotal        = items.reduce((s, it) => s + (parseFloat(String(it.qty))||0) * (parseFloat(it.rate)||0), 0);
  const taxableSubtotal = items.reduce((s, it) => it.taxable ? s + (parseFloat(String(it.qty))||0)*(parseFloat(it.rate)||0) : s, 0);
  const gstAmt    = taxProv ? (taxableSubtotal * taxProv.gst)   / 100 : 0;
  const pstAmt    = taxProv ? (taxableSubtotal * taxProv.pst)   / 100 : 0;
  const hstAmt    = taxProv ? (taxableSubtotal * taxProv.hst)   / 100 : 0;
  const qstAmt    = taxProv ? (taxableSubtotal * taxProv.qst)   / 100 : 0;
  const totalTax  = gstAmt + pstAmt + hstAmt + qstAmt;
  const grandTotal = subtotal + totalTax;
  const dueDate    = addDays(invoiceDate, paymentTerms);

  // Does any line item exceed available stock for its linked product?
  const hasStockIssue = items.some((it) => {
    const avail = getAvailableStock(products, it.product_id);
    const qty = parseFloat(String(it.qty)) || 0;
    return avail !== null && qty > avail;
  });

  const handleSave = async () => {
    const headers = getAuthHeaders();
    if (!headers) { setSaveError("No auth token. Please log in first."); return; }
    if (!invoiceNum) { setSaveError("Please enter an invoice number."); return; }
    if (hasStockIssue) { setSaveError("One or more items exceed available stock. Please fix the quantity before saving."); return; }
    setSaving(true); setSaveError(""); setSaveSuccess(false);

    const payload = {
      client_id: selectedClientId || null,
      invoice_number: `${invoicePrefix}-${invoiceNum}`,
      invoice_prefix: invoicePrefix,
      invoice_date: invoiceDate,
      due_date: dueDate,
      status: invoiceStatus === "DRAFT" ? "Draft" : invoiceStatus === "UNPAID" ? "Unpaid" : "Paid",
      currency, notes, terms,
      footer_note: seller.footerNote || "",
      gst_rate: taxProv?.gst || 0,
      pst_rate: taxProv?.pst || 0,
      hst_rate: taxProv?.hst || 0,
      gst_amount: gstAmt,
      pst_amount: pstAmt,
      hst_amount: hstAmt,
      total_tax: totalTax,
      hst_registration_number: seller.taxNumber || null,
      subtotal,
      total_amount: grandTotal,
      amount_paid: invoiceStatus === "PAID" ? grandTotal : 0,
      balance_due: invoiceStatus === "PAID" ? 0 : grandTotal,
      seller_business_name: seller.businessName,
      seller_address: seller.address,
      seller_city: seller.city,
      seller_province: seller.province,
      seller_postal_code: seller.postalCode,
      seller_country: seller.country,
      seller_phone: seller.phone,
      seller_email: seller.email,
      buyer_business_name: buyer.businessName,
      buyer_address: buyer.address,
      buyer_city: buyer.city,
      buyer_province: buyer.province,
      buyer_postal_code: buyer.postalCode,
      buyer_country: buyer.country,
      buyer_phone: buyer.phone,
      buyer_email: buyer.email,
      buyer_tax_number: buyer.taxNumber,
      payment_method: paymentMethod,
      payment_details: paymentDetails,
      payment_terms: `Net ${paymentTerms}`,
      items: items.map(({ description, qty, rate, taxable, product_id }) => ({
        description,
        qty: parseFloat(String(qty)) || 0,
        rate: parseFloat(rate) || 0,
        taxable,
        product_id: product_id || null,
        total: (parseFloat(String(qty)) || 0) * (parseFloat(rate) || 0),
      })),
    };

    try {
      const existingId = editInvoice?.id || savedInvoiceData?.savedInvoice?.id;
      const isUpdate = !!existingId;
      const url = isUpdate
        ? `${apiBaseUrl}/api/invoices/${existingId}`
        : `${apiBaseUrl}/api/invoices`;
      const method = isUpdate ? "PUT" : "POST";

      const res = await fetch(url, { method, headers, body: JSON.stringify(payload) });
      const data = await res.json();
      if (!res.ok) { setSaveError(data.message || `Save failed (${res.status})`); return; }

      setSaveSuccess(true);

      // 6️⃣ Auto-adjust stock based on invoice status transition (deduct on Paid, restore if un-Paid)
      const previousStatus = editInvoice
        ? (editInvoice.status === "Paid" ? "PAID" : editInvoice.status === "Unpaid" ? "UNPAID" : "DRAFT")
        : null;
      const becomingPaid      = invoiceStatus === "PAID" && previousStatus !== "PAID";
      const unpayingFromPaid  = previousStatus === "PAID" && invoiceStatus !== "PAID";
      const stockItems = items.filter((it) => it.product_id && parseFloat(it.qty) > 0);
      if (becomingPaid) {
        for (const it of stockItems) {
          try {
            await fetch(`${apiBaseUrl}/api/products/${it.product_id}/stock-out`, {
              method: "POST",
              headers,
              body: JSON.stringify({
                quantity: parseInt(it.qty, 10),
                reason: `Sold via Invoice ${invoicePrefix}-${invoiceNum}`,
                invoice_id: data.invoice?.id || existingId || null,
              }),
            });
          } catch (_) { /* structural non-blocking fallback */ }
        }
      } else if (unpayingFromPaid) {
        for (const it of stockItems) {
          try {
            await fetch(`${apiBaseUrl}/api/products/${it.product_id}/stock-in`, {
              method: "POST",
              headers,
              body: JSON.stringify({
                quantity: parseInt(it.qty, 10),
                reason: `Reversed — Invoice ${invoicePrefix}-${invoiceNum} status changed back to ${invoiceStatus}`,
                invoice_id: existingId || null,
              }),
            });
          } catch (_) { /* structural non-blocking fallback */ }
        }
      }

      const confirmedNum = isUpdate
        ? invoiceNum
        : (data.invoice?.invoice_number
          ? String(data.invoice.invoice_number).split('-').pop()
          : invoiceNum);

      if (confirmedNum !== invoiceNum) {
        setInvoiceNum(confirmedNum);
      }

      setSavedInvoiceData({
        grandTotal, subtotal, totalTax, gstAmt, pstAmt, hstAmt, qstAmt, taxProv,
        invoicePrefix,
        invoiceNum: confirmedNum,
        dueDate, invoiceDate, paymentTerms, currency, invoiceStatus,
        seller: { ...seller }, buyer: { ...buyer }, items: [...items],
        businessLogoUrl, businessSignatureUrl, terms, notes,
        paymentMethod, paymentDetails,
        savedInvoice: data.invoice || { id: existingId },
      });

      setDownloadReady(true);
      setTimeout(() => setSaveSuccess(false), 4000);
    } catch (err) {
      setSaveError(`Network error: ${err.message}`);
    } finally {
      setSaving(false);
    }
  };

  const handleDownloadPDFClick = () => {
    if (!savedInvoiceData) return;
    setSavedInvoiceData(prev => ({
      ...prev,
      grandTotal, subtotal, totalTax, gstAmt, pstAmt, hstAmt, qstAmt, taxProv,
      invoicePrefix, invoiceNum, dueDate, invoiceDate, paymentTerms, currency, invoiceStatus,
      seller: { ...seller }, buyer: { ...buyer }, items: [...items],
      businessLogoUrl, businessSignatureUrl, terms, notes,
      paymentMethod, paymentDetails,
    }));
    setShowTemplateSelector(true);
  };

  const handleTemplateSelect = (templateId) => {
    setShowTemplateSelector(false);
    generateCanadaInvoicePDF(templateId, savedInvoiceData);
  };

  const handleDone = () => {
    if (onSave && savedInvoiceData) { onSave(savedInvoiceData.savedInvoice); }
    else if (onCancel) { onCancel(); }
  };

  const C = {
    blue: "#2563eb", blueLt: "#eff6ff", red: "#dc2626", redLt: "#fff1f2",
    green: "#059669", greenLt: "#ecfdf5", greenText: "#065f46",
    purple: "#7c3aed", purpleLt: "#f5f3ff", maple: "#c41e3a", mapleLt: "#fff0f3",
    gray: "#6b7280", grayLt: "#f9fafb", border: "#e5e7eb", text: "#111827", textMid: "#374151",
  };
  const grid2 = { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 };
  const grid3 = { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16 };
  const grid4 = { display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 16 };
  const statusCfg = STATUS_CONFIG[invoiceStatus] || STATUS_CONFIG.DRAFT;
  const isPaymentEnabled = invoiceStatus === "PAID";

  const paymentTip = () => {
    if (paymentMethod === "e-Transfer") return { bg: "#eff6ff", border: "#bfdbfe", color: C.blue, text: "💡 Tip: Enable Autodeposit on your email to receive e-Transfers instantly without a security question." };
    if (paymentMethod === "Bank Transfer (EFT)") return { bg: "#f0fdf4", border: "#86efac", color: C.green, text: "🏦 Include your Institution Number, Transit Number, and Account Number for EFT payments." };
    if (paymentMethod === "Cheque") return { bg: "#fffbeb", border: "#fde68a", color: "#92400e", text: "📬 Make cheques payable to the business name listed on this invoice." };
    if (paymentMethod === "Credit Card" || paymentMethod === "Debit Card") return { bg: "#f5f3ff", border: "#e9d5ff", color: C.purple, text: "💳 A processing fee may apply for card payments. Please confirm with the business." };
    return null;
  };
  const tip = paymentTip();

  const partyFields = (party, set, isAutoFilled = false) => (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <div>
        <FieldLabel>Business / Client Name</FieldLabel>
        <TextInput value={party.businessName} onChange={(e) => set((p) => ({ ...p, businessName: e.target.value }))} placeholder="Business or individual name" style={isAutoFilled ? { borderColor: "#86efac", background: "#f0fdf4" } : {}} />
        {isAutoFilled && (<div style={{ marginTop: 4, fontSize: 11, color: "#065f46", fontWeight: 600 }}>✓ Auto-filled from Business Profile. You can edit.</div>)}
      </div>
      <div>
        <FieldLabel>Address</FieldLabel>
        <TextInput value={party.address} onChange={(e) => set((p) => ({ ...p, address: e.target.value }))} placeholder="Street address" style={isAutoFilled ? { borderColor: "#86efac", background: "#f0fdf4" } : {}} />
      </div>
      <div style={grid3}>
        <div><FieldLabel>City</FieldLabel><TextInput value={party.city} onChange={(e) => set((p) => ({ ...p, city: e.target.value }))} placeholder="City" style={isAutoFilled ? { borderColor: "#86efac", background: "#f0fdf4" } : {}} /></div>
        <div><FieldLabel>Province</FieldLabel><SelectInput value={party.province} onChange={(e) => set((p) => ({ ...p, province: e.target.value }))} style={isAutoFilled ? { borderColor: "#86efac", background: "#f0fdf4" } : {}}><option value="">Select</option>{CANADA_PROVINCES.map((pr) => (<option key={pr.code} value={pr.code}>{pr.name} ({pr.code})</option>))}</SelectInput></div>
        <div><FieldLabel>Postal Code</FieldLabel><TextInput value={party.postalCode} onChange={(e) => set((p) => ({ ...p, postalCode: e.target.value }))} placeholder="A1A 1A1" style={isAutoFilled ? { borderColor: "#86efac", background: "#f0fdf4" } : {}} /></div>
      </div>
      <div style={grid2}>
        <div><FieldLabel>Phone</FieldLabel><TextInput value={party.phone} onChange={(e) => set((p) => ({ ...p, phone: e.target.value }))} placeholder="+1 (416) 000-0000" style={isAutoFilled ? { borderColor: "#86efac", background: "#f0fdf4" } : {}} /></div>
        <div><FieldLabel>Email</FieldLabel><TextInput type="email" value={party.email} onChange={(e) => set((p) => ({ ...p, email: e.target.value }))} placeholder="email@example.com" style={isAutoFilled ? { borderColor: "#86efac", background: "#f0fdf4" } : {}} /></div>
      </div>
      <div>
        <FieldLabel>GST / HST Registration Number</FieldLabel>
        <TextInput style={{ fontFamily: "monospace", ...(isAutoFilled ? { borderColor: "#86efac", background: "#f0fdf4" } : {}) }} value={party.taxNumber} onChange={(e) => set((p) => ({ ...p, taxNumber: e.target.value }))} placeholder="123456789 RT 0001" />
      </div>
    </div>
  );

  const buyerSection = (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <BuyerNameDropdown clients={clients} loading={clientsLoading} error={clientsError} selectedId={selectedClientId} value={buyer.businessName} onSelect={handleClientSelect} onChange={(val) => { setSelectedClientId(""); setBuyer((p) => ({ ...p, businessName: val })); }} />
      <div><FieldLabel>Address</FieldLabel><TextInput value={buyer.address} onChange={(e) => setBuyer((p) => ({ ...p, address: e.target.value }))} placeholder="Street address" style={selectedClientId ? { borderColor: "#86efac", background: "#f0fdf4" } : {}} /></div>
      <div style={grid3}>
        <div><FieldLabel>City</FieldLabel><TextInput value={buyer.city} onChange={(e) => setBuyer((p) => ({ ...p, city: e.target.value }))} placeholder="City" style={selectedClientId ? { borderColor: "#86efac", background: "#f0fdf4" } : {}} /></div>
        <div><FieldLabel>Province</FieldLabel><SelectInput value={buyer.province} onChange={(e) => setBuyer((p) => ({ ...p, province: e.target.value }))} style={selectedClientId ? { borderColor: "#86efac", background: "#f0fdf4" } : {}}><option value="">Select</option>{CANADA_PROVINCES.map((pr) => (<option key={pr.code} value={pr.code}>{pr.name} ({pr.code})</option>))}</SelectInput></div>
        <div><FieldLabel>Postal Code</FieldLabel><TextInput value={buyer.postalCode} onChange={(e) => setBuyer((p) => ({ ...p, postalCode: e.target.value }))} placeholder="A1A 1A1" style={selectedClientId ? { borderColor: "#86efac", background: "#f0fdf4" } : {}} /></div>
      </div>
      <div style={grid2}>
        <div><FieldLabel>Phone</FieldLabel><TextInput value={buyer.phone} onChange={(e) => setBuyer((p) => ({ ...p, phone: e.target.value }))} placeholder="+1 (416) 000-0000" style={selectedClientId ? { borderColor: "#86efac", background: "#f0fdf4" } : {}} /></div>
        <div><FieldLabel>Email</FieldLabel><TextInput type="email" value={buyer.email} onChange={(e) => setBuyer((p) => ({ ...p, email: e.target.value }))} placeholder="email@example.com" style={selectedClientId ? { borderColor: "#86efac", background: "#f0fdf4" } : {}} /></div>
      </div>
      <div><FieldLabel>GST / HST Registration Number</FieldLabel><TextInput style={{ fontFamily: "monospace", ...(selectedClientId ? { borderColor: "#86efac", background: "#f0fdf4" } : {}) }} value={buyer.taxNumber} onChange={(e) => setBuyer((p) => ({ ...p, taxNumber: e.target.value }))} placeholder="123456789 RT 0001" /></div>
    </div>
  );

  const sellerIsAutoFilled = !!seller.businessName;
  const hasToken = !!(token || (typeof localStorage !== "undefined" && localStorage.getItem("token")) || (typeof sessionStorage !== "undefined" && sessionStorage.getItem("token")));
  const displayInvoiceNumber = editInvoice?.invoice_number ? editInvoice.invoice_number : `${invoicePrefix}-${invoiceNum}`;

  return (
    <div style={{ fontFamily: "'Inter','Segoe UI',sans-serif", background: "#f3f4f6", minHeight: "100vh" }}>
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } } ::-webkit-scrollbar { width: 6px; } ::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }`}</style>

      {showTemplateSelector && (
        <CanadaTemplateSelector
          onClose={() => setShowTemplateSelector(false)}
          onSelect={handleTemplateSelect}
        />
      )}

      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "28px 24px 60px" }}>

        {!hasToken && (<AuthBanner message="Pass a 'token' prop or store your JWT in localStorage under 'token' to auto-load your business profile and clients." />)}
        {profileError && (<div style={{ padding: "10px 16px", background: "#fff1f2", border: "1px solid #fecaca", borderRadius: 8, marginBottom: 16, fontSize: 12, color: "#dc2626" }}>⚠️ Business Profile: {profileError}</div>)}
        {profileLoading && (<div style={{ padding: "10px 16px", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, marginBottom: 16, fontSize: 12, color: "#2563eb", display: "flex", alignItems: "center", gap: 8 }}><span style={{ display: "inline-block", width: 14, height: 14, border: "2px solid #2563eb", borderTopColor: "transparent", borderRadius: "50%", animation: "spin 0.7s linear infinite" }} />Loading business profile...</div>)}
        {saveError && (<div style={{ padding: "10px 16px", background: "#fff1f2", border: "1px solid #fecaca", borderRadius: 8, marginBottom: 16, fontSize: 12, color: "#dc2626", display: "flex", alignItems: "center", gap: 8 }}>❌ Save Error: {saveError}<span onClick={() => setSaveError("")} style={{ marginLeft: "auto", cursor: "pointer", fontWeight: 700 }}>✕</span></div>)}
        {saveSuccess && (<div style={{ padding: "10px 16px", background: "#f0fdf4", border: "1px solid #86efac", borderRadius: 8, marginBottom: 16, fontSize: 12, color: "#065f46", fontWeight: 600 }}>
          ✅ {editInvoice || savedInvoiceData?.savedInvoice?.id ? "Invoice updated successfully!" : "Invoice saved! Now click \"Download PDF\" to choose a theme and download."}
        </div>)}

        {editInvoice && (
          <div style={{ padding: "10px 16px", background: "#fefce8", border: "1px solid #fde68a", borderRadius: 8, marginBottom: 16, fontSize: 12, color: "#92400e", fontWeight: 600, display: "flex", alignItems: "center", gap: 8 }}>
            ✏️ Editing Invoice: <span style={{ fontFamily: "monospace", color: "#78350f" }}>{displayInvoiceNumber}</span>
            <span style={{ fontWeight: 400, marginLeft: 4 }}>— Changes will update the existing invoice.</span>
          </div>
        )}

        {/* Top bar */}
        <div style={{ marginBottom: 20 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "#fff", border: `1px solid ${C.border}`, borderRadius: 12, padding: "16px 24px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
              <div style={{ width: 46, height: 46, borderRadius: 10, background: C.mapleLt, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24 }}>🍁</div>
              <div>
                <div style={{ fontSize: 17, fontWeight: 700, color: C.text }}>Canada Tax Invoice</div>
                <div style={{ fontSize: 12, color: C.gray }}>GST / HST / PST / QST Compliant</div>
              </div>
              <span style={{ padding: "3px 12px", borderRadius: 6, fontSize: 11, fontWeight: 700, border: `1.5px solid ${statusCfg.borderColor}`, color: statusCfg.color, background: statusCfg.bg }}>{statusCfg.label}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "6px 12px", borderRadius: 8, background: hasToken ? "#f0fdf4" : "#fff1f2", border: `1px solid ${hasToken ? "#86efac" : "#fecaca"}` }}>
                <span style={{ fontSize: 12 }}>{hasToken ? "🔓" : "🔒"}</span>
                <span style={{ fontSize: 11, fontWeight: 700, color: hasToken ? "#059669" : "#dc2626" }}>{hasToken ? "Authenticated" : "No Token"}</span>
              </div>
              {onCancel && (<button onClick={onCancel} style={{ padding: "8px 18px", borderRadius: 8, border: "1px solid #e5e7eb", background: "#fff", color: "#6b7280", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Cancel</button>)}

              <button
                onClick={handleSave}
                disabled={saving || hasStockIssue}
                title={hasStockIssue ? "Fix quantities exceeding available stock before saving" : undefined}
                style={{
                  padding: "8px 22px", borderRadius: 8, border: "none",
                  background: (saving || hasStockIssue) ? "#93c5fd" : (editInvoice || savedInvoiceData?.savedInvoice?.id) ? "#059669" : "#2563eb",
                  color: "#fff", fontSize: 13, fontWeight: 700,
                  cursor: (saving || hasStockIssue) ? "not-allowed" : "pointer",
                  opacity: hasStockIssue ? 0.65 : 1,
                  display: "flex", alignItems: "center", gap: 8, transition: "background .2s",
                }}
              >
                {saving && (<span style={{ display: "inline-block", width: 13, height: 13, border: "2px solid #fff", borderTopColor: "transparent", borderRadius: "50%", animation: "spin 0.7s linear infinite" }} />)}
                {saving ? "Saving..." : hasStockIssue ? "⚠️ Fix Stock Issue" : (editInvoice || savedInvoiceData?.savedInvoice?.id) ? "💾 Update Invoice" : "💾 Save Invoice"}
              </button>

              <button
                onClick={handleDownloadPDFClick}
                disabled={!downloadReady}
                style={{ padding: "8px 22px", borderRadius: 8, border: "none", background: downloadReady ? "#c41e3a" : "#d1d5db", color: "#fff", fontSize: 13, fontWeight: 700, cursor: downloadReady ? "pointer" : "not-allowed", opacity: downloadReady ? 1 : 0.55, display: "flex", alignItems: "center", gap: 8, transition: "all .2s" }}
              >
                🍁 {downloadReady ? "Choose Theme & Download PDF" : "Save First to Download"}
              </button>

              {downloadReady && (<button onClick={handleDone} style={{ padding: "8px 18px", borderRadius: 8, border: "1.5px solid #e5e7eb", background: "#fff", color: "#374151", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>✓ Done / Close</button>)}
            </div>
          </div>
        </div>

        {/* Invoice header */}
        <Card style={{ textAlign: "center", padding: "36px 24px 28px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginBottom: 10 }}>
            <span style={{ color: C.maple }}>🍁</span>
            <span style={{ fontSize: 11, fontWeight: 700, color: C.maple, letterSpacing: 1.5 }}>CANADA REVENUE AGENCY COMPLIANT</span>
          </div>
          <div style={{ fontSize: 34, fontWeight: 800, color: C.text, letterSpacing: 2, marginBottom: 6 }}>TAX INVOICE</div>
          <div style={{ fontSize: 13, color: C.gray }}>GST / HST / PST / QST — Excise Tax Act Compliant Invoice</div>
        </Card>

        {/* Invoice meta */}
        <Card>
          <div style={grid4}>
            <div>
              <FieldLabel>INVOICE NUMBER</FieldLabel>
              <div style={{ display: "flex" }}>
                <div style={{ padding: "9px 12px", background: "#f3f4f6", border: `1px solid ${C.border}`, borderRight: "none", borderRadius: "8px 0 0 8px", fontSize: 13, color: C.gray, whiteSpace: "nowrap" }}>{invoicePrefix}-</div>
                <TextInput value={invoiceNum} onChange={() => {}} readOnly style={{ borderRadius: "0 8px 8px 0", background: "#f3f4f6", cursor: "not-allowed", color: "#6b7280", userSelect: "none" }} placeholder={invoiceNumLoading ? "Loading..." : "001"} />
              </div>
              {invoiceNumLoading && (<div style={{ fontSize: 11, color: C.blue, marginTop: 4, display: "flex", alignItems: "center", gap: 5 }}><span style={{ display: "inline-block", width: 10, height: 10, border: "2px solid #2563eb", borderTopColor: "transparent", borderRadius: "50%", animation: "spin 0.7s linear infinite" }} />Auto-generating number...</div>)}
              {editInvoice && (
                <div style={{ fontSize: 11, color: "#059669", marginTop: 4, fontWeight: 600 }}>✏️ Editing: {displayInvoiceNumber}</div>
              )}
            </div>
            <div>
              <FieldLabel required>INVOICE DATE</FieldLabel>
              <TextInput type="date" value={invoiceDate} onChange={(e) => setInvoiceDate(e.target.value)} />
              <div style={{ fontSize: 11, color: C.gray, marginTop: 4 }}>{invoiceDate}</div>
            </div>
            <div>
              <FieldLabel>PAYMENT TERMS (days)</FieldLabel>
              <SelectInput value={paymentTerms} onChange={(e) => setPaymentTerms(Number(e.target.value))}>
                {[7,14,15,30,45,60,90].map((d) => (<option key={d} value={d}>Net {d}</option>))}
              </SelectInput>
              <div style={{ fontSize: 11, color: C.gray, marginTop: 4 }}>Due: {dueDate}</div>
            </div>
            <div>
              <FieldLabel>INVOICE STATUS</FieldLabel>
              <SelectInput value={invoiceStatus} onChange={(e) => setInvoiceStatus(e.target.value)} style={{ borderColor: statusCfg.borderColor, background: statusCfg.bg, color: statusCfg.color, fontWeight: 700 }}>
                <option value="DRAFT">📝 Draft</option>
                <option value="UNPAID">🔴 Unpaid</option>
                <option value="PAID">✅ Paid</option>
              </SelectInput>
              <div style={{ fontSize: 11, marginTop: 4, color: statusCfg.color, fontWeight: 600 }}>
                {invoiceStatus === "DRAFT" && "Draft — not yet sent"}
                {invoiceStatus === "UNPAID" && "Sent — awaiting payment"}
                {invoiceStatus === "PAID" && "Payment received ✓"}
              </div>
            </div>
          </div>
          <div style={{ marginTop: 18, padding: "10px 16px", background: C.grayLt, borderRadius: 8, display: "flex", flexWrap: "wrap", gap: 20, fontSize: 12 }}>
            {[["Currency", currency === "CAD" ? "CAD (CA$)" : "USD (US$)", C.blue], ["Date Format", "YYYY-MM-DD", C.blue], ["Tax Method", "Point of Supply (Buyer Province)", C.blue], ["Tax Inclusive", "No", C.red]].map(([k, v, col]) => (<span key={k} style={{ color: C.gray }}>{k}: <strong style={{ color: col }}>{v}</strong></span>))}
          </div>
          {taxProv && <div style={{ marginTop: 14 }}><TaxBadge province={taxProv} /></div>}
        </Card>

        {/* Seller + Buyer */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
          <Card style={{ margin: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
              <div style={{ width: 34, height: 34, borderRadius: 8, background: C.blueLt, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 17 }}>🏢</div>
              <span style={{ fontSize: 15, fontWeight: 700, color: C.text }}>Seller (From)</span>
              {sellerIsAutoFilled && (<span style={{ marginLeft: "auto", padding: "2px 8px", borderRadius: 4, fontSize: 10, fontWeight: 700, background: "#dcfce7", color: "#059669", border: "1px solid #86efac" }}>✓ Auto-filled</span>)}
            </div>
            {businessLogoUrl && (
              <div style={{ marginBottom: 16, padding: "12px", background: C.grayLt, borderRadius: 10, border: `1px solid ${C.border}`, display: "flex", alignItems: "center", gap: 12 }}>
                <img src={businessLogoUrl} alt="Business Logo" style={{ maxHeight: 56, maxWidth: 160, objectFit: "contain", borderRadius: 6 }} onError={(e) => { e.target.style.display = "none"; }} />
                <div><div style={{ fontSize: 11, fontWeight: 700, color: C.green }}>✓ Logo loaded</div><div style={{ fontSize: 11, color: C.gray }}>From Business Profile</div></div>
              </div>
            )}
            {partyFields(seller, setSeller, sellerIsAutoFilled)}
          </Card>
          <Card style={{ margin: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
              <div style={{ width: 34, height: 34, borderRadius: 8, background: C.greenLt, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 17 }}>👤</div>
              <span style={{ fontSize: 15, fontWeight: 700, color: C.text }}>Buyer (To)</span>
              {clients.length > 0 && (<span style={{ marginLeft: "auto", padding: "2px 8px", borderRadius: 4, fontSize: 10, fontWeight: 700, background: C.blueLt, color: C.blue, border: "1px solid #bfdbfe" }}>{clients.length} clients</span>)}
            </div>
            {buyerSection}
          </Card>
        </div>

        {/* Line items */}
        <Card>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
            <span style={{ fontSize: 16, fontWeight: 700, color: C.text }}>Line Items</span>
            <button onClick={() => setItems((prev) => [...prev, createEmptyItem()])} style={{ padding: "7px 16px", background: C.blueLt, border: `1px solid #bfdbfe`, borderRadius: 8, color: C.blue, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>+ Add Item</button>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "40px 3fr 90px 110px 80px 110px 36px", gap: 8, padding: "9px 8px", background: "#f8fafc", borderRadius: 8, marginBottom: 8 }}>
            {["#","DESCRIPTION","QTY","RATE (CA$)","TAXABLE","TOTAL (CA$)",""].map((h) => (<div key={h} style={{ fontSize: 10, fontWeight: 700, color: C.gray, letterSpacing: 0.4 }}>{h}</div>))}
          </div>
          {items.map((it, idx) => {
            const lineTotal = (parseFloat(String(it.qty))||0) * (parseFloat(it.rate)||0);
            const availableStock = getAvailableStock(products, it.product_id);
            const enteredQty = parseFloat(String(it.qty)) || 0;
            const stockExceeded = availableStock !== null && enteredQty > availableStock;

            return (
              <React.Fragment key={it.id}>
                <div style={{ display: "grid", gridTemplateColumns: "40px 3fr 90px 110px 80px 110px 36px", gap: 8, marginBottom: stockExceeded ? 4 : 10, alignItems: "center" }}>
                  <div style={{ fontSize: 13, color: C.gray, fontWeight: 600 }}>{idx + 1}</div>

                  <ProductPicker
                    products={products}
                    loading={productsLoading}
                    value={it.description}
                    onManualChange={(val) => {
                      updateItem(it.id, "description", val);
                      updateItem(it.id, "product_id", "");
                    }}
                    onPick={(p) => {
                      updateItem(it.id, "description", p.product_name);
                      updateItem(it.id, "rate", p.selling_price || 0);
                      updateItem(it.id, "taxable", p.is_taxable !== false);
                      updateItem(it.id, "product_id", p.id);
                    }}
                  />

                  <TextInput
                    type="number"
                    min={0}
                    value={it.qty}
                    onChange={(e) => updateItem(it.id, "qty", e.target.value)}
                    style={stockExceeded ? { borderColor: "#dc2626", background: "#fff1f0" } : {}}
                  />
                  <TextInput type="number" min={0} value={it.rate} onChange={(e) => updateItem(it.id, "rate", e.target.value)} placeholder="0.00" />
                  <label style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6, cursor: "pointer" }}>
                    <input type="checkbox" checked={it.taxable} onChange={(e) => updateItem(it.id, "taxable", e.target.checked)} style={{ accentColor: C.blue, width: 15, height: 15 }} />
                    <span style={{ fontSize: 11, color: it.taxable ? C.blue : C.gray, fontWeight: 600 }}>{it.taxable ? "Yes" : "No"}</span>
                  </label>
                  <div style={{ fontSize: 13, fontWeight: 600, color: C.text, textAlign: "right" }}>{fmtCurrency(lineTotal, currency)}</div>
                  <button onClick={() => removeItem(it.id)} style={{ width: 32, height: 32, background: "#fff1f0", border: "1px solid #fecaca", borderRadius: 6, color: C.red, fontSize: 18, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
                </div>

                {stockExceeded && (
                  <div style={{
                    marginBottom: 10, marginLeft: 48, padding: "8px 14px",
                    background: "#fff1f0", border: "1px solid #fecaca", borderRadius: 8,
                    fontSize: 12.5, color: "#dc2626", fontWeight: 600,
                    display: "flex", alignItems: "center", gap: 8,
                  }}>
                    ⚠️ Insufficient stock — only <strong>{availableStock}</strong> unit{availableStock === 1 ? "" : "s"} available for "<strong>{it.description}</strong>", but you entered <strong>{enteredQty}</strong>.
                  </div>
                )}
              </React.Fragment>
            );
          })}

          {hasStockIssue && (
            <div style={{
              marginTop: 10, padding: "12px 16px", background: "#fef2f2", border: "1.5px solid #fca5a5",
              borderRadius: 10, fontSize: 13, color: "#991b1b", fontWeight: 700,
              display: "flex", alignItems: "center", gap: 10,
            }}>
              ⚠️ This invoice cannot be saved — one or more items exceed available stock. Please adjust quantities above.
            </div>
          )}
        </Card>

        {/* Totals */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
          <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 12, padding: 24 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
              <span style={{ color: C.green }}>📄</span>
              <span style={{ fontSize: 11, fontWeight: 700, color: C.green, letterSpacing: 1 }}>TOTAL AMOUNT IN WORDS</span>
            </div>
            <div style={{ fontSize: 15, fontWeight: 800, color: C.text, marginBottom: 16, lineHeight: 1.5 }}>{numberToWords(grandTotal)}</div>
            <div style={{ height: 1, background: "#86efac", marginBottom: 14 }} />
            <div style={{ fontSize: 12, color: C.green }}>✓ Includes applicable Canadian taxes</div>
            <div style={{ fontSize: 12, color: C.green, marginTop: 4 }}>✓ Currency: {currency === "CAD" ? "Canadian Dollar (CAD)" : "US Dollar (USD)"}</div>
          </div>
          <div style={{ background: "#fff", border: `1px solid ${C.border}`, borderRadius: 12, padding: 24 }}>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "9px 0", borderBottom: "1px solid #f3f4f6", fontSize: 13, color: C.textMid }}><span>Subtotal (before tax)</span><span style={{ fontWeight: 600 }}>{fmtCurrency(subtotal, currency)}</span></div>
            {taxProv && (
              <>
                {hstAmt > 0 && (<div style={{ display: "flex", justifyContent: "space-between", padding: "9px 0", borderBottom: "1px solid #f3f4f6", fontSize: 13, color: C.textMid }}><span>HST @ {taxProv.hst}% <span style={{ fontSize: 11, color: C.gray }}>({taxProv.name})</span></span><span style={{ fontWeight: 600 }}>{fmtCurrency(hstAmt, currency)}</span></div>)}
                {gstAmt > 0 && (<div style={{ display: "flex", justifyContent: "space-between", padding: "9px 0", borderBottom: "1px solid #f3f4f6", fontSize: 13, color: C.textMid }}><span>GST @ {taxProv.gst}%</span><span style={{ fontWeight: 600 }}>{fmtCurrency(gstAmt, currency)}</span></div>)}
                {pstAmt > 0 && (<div style={{ display: "flex", justifyContent: "space-between", padding: "9px 0", borderBottom: "1px solid #f3f4f6", fontSize: 13, color: C.textMid }}><span>PST @ {taxProv.pst}% <span style={{ fontSize: 11, color: C.gray }}>({taxProv.name})</span></span><span style={{ fontWeight: 600 }}>{fmtCurrency(pstAmt, currency)}</span></div>)}
                {qstAmt > 0 && (<div style={{ display: "flex", justifyContent: "space-between", padding: "9px 0", borderBottom: "1px solid #f3f4f6", fontSize: 13, color: C.textMid }}><span>QST @ {taxProv.qst}% <span style={{ fontSize: 11, color: C.gray }}>(Quebec)</span></span><span style={{ fontWeight: 600 }}>{fmtCurrency(qstAmt, currency)}</span></div>)}
                {totalTax > 0 && (<div style={{ display: "flex", justifyContent: "space-between", padding: "9px 0", borderBottom: "1px solid #f3f4f6", fontSize: 13, color: C.purple, fontWeight: 600 }}><span>Total Tax</span><span>{fmtCurrency(totalTax, currency)}</span></div>)}
              </>
            )}
            {!taxProv && (<div style={{ padding: "10px 14px", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, fontSize: 12, color: "#92400e", margin: "10px 0" }}>⚠️ Select buyer's province to calculate applicable taxes</div>)}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", paddingTop: 14, borderTop: `2px solid ${C.border}`, marginTop: 4 }}>
              <span style={{ fontSize: 15, fontWeight: 700, color: C.text }}>Invoice Total</span>
              <span style={{ fontSize: 26, fontWeight: 800, color: C.blue }}>{fmtCurrency(grandTotal, currency)}</span>
            </div>
            <div style={{ fontSize: 12, color: C.gray, marginTop: 6, textAlign: "right" }}>Due: {dueDate} (Net {paymentTerms})</div>
          </div>
        </div>

        {/* Payment Method */}
        <Card style={{ opacity: isPaymentEnabled ? 1 : 0.45, pointerEvents: isPaymentEnabled ? "auto" : "none", transition: "opacity 0.25s", position: "relative" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
            <span>💳</span>
            <span style={{ fontSize: 15, fontWeight: 700, color: C.text }}>Payment Method</span>
            {!isPaymentEnabled && (<span style={{ marginLeft: "auto", padding: "3px 12px", borderRadius: 6, fontSize: 11, fontWeight: 700, background: "#f3f4f6", color: "#6b7280", border: "1px solid #e5e7eb" }}>🔒 Available only when Status is PAID</span>)}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <div>
              <FieldLabel>Payment Method</FieldLabel>
              <SelectInput value={paymentMethod} onChange={(e) => { setPaymentMethod(e.target.value); setPaymentDetails(""); }}>
                <option>e-Transfer</option><option>Bank Transfer (EFT)</option><option>Cheque</option><option>Credit Card</option><option>Debit Card</option><option>Cash</option><option>PayPal</option><option>Stripe</option><option>Other</option>
              </SelectInput>
            </div>
            <div>
              <FieldLabel>Payment Details</FieldLabel>
              <TextInput value={paymentDetails} onChange={(e) => setPaymentDetails(e.target.value)} placeholder={paymentMethod === "e-Transfer" ? "Send to: payments@yourbusiness.ca" : paymentMethod === "Bank Transfer (EFT)" ? "Bank: RBC | Transit: 00123 | Account: 1234567" : paymentMethod === "Cheque" ? "Payable to: Your Business Name" : paymentMethod === "PayPal" ? "PayPal email: payments@yourbusiness.ca" : paymentMethod === "Stripe" ? "Stripe payment link or instructions" : "Enter payment details..."} />
            </div>
          </div>
          {tip && (<div style={{ marginTop: 12, padding: "10px 14px", background: tip.bg, border: `1px solid ${tip.border}`, borderRadius: 8, fontSize: 12, color: tip.color }}>{tip.text}</div>)}
          {paymentDetails && (<div style={{ marginTop: 12, padding: "10px 14px", background: C.grayLt, border: `1px solid ${C.border}`, borderRadius: 8, fontSize: 12, color: C.textMid, display: "flex", alignItems: "center", gap: 8 }}><span style={{ fontWeight: 700, color: C.gray }}>Payment Info on Invoice:</span><span>{paymentMethod} — {paymentDetails}</span></div>)}
        </Card>

        {/* Terms + Signature */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
          <Card style={{ margin: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
              <span>📄</span>
              <span style={{ fontSize: 11, fontWeight: 700, color: C.gray, letterSpacing: 1 }}>TERMS & CONDITIONS</span>
            </div>
            <textarea value={terms} onChange={(e) => setTerms(e.target.value)} style={{ width: "100%", padding: "12px", border: `1px solid ${C.border}`, borderRadius: 8, fontSize: 13, fontFamily: "inherit", resize: "vertical", minHeight: 130, boxSizing: "border-box", outline: "none", lineHeight: 1.8 }} />
          </Card>
          <Card style={{ margin: 0 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: C.gray, letterSpacing: 1, marginBottom: 20 }}>AUTHORIZED SIGNATURE</div>
            {businessSignatureUrl ? (
              <div style={{ border: "1.5px solid #86efac", borderRadius: 8, padding: "16px 20px", marginBottom: 16, background: "#f0fdf4", display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
                <img src={businessSignatureUrl} alt="Authorized Signature" style={{ maxHeight: 80, maxWidth: "100%", objectFit: "contain" }} onError={(e) => { e.target.style.display = "none"; }} />
                <div style={{ fontSize: 11, color: C.green, fontWeight: 600 }}>✓ Signature loaded from Business Profile</div>
              </div>
            ) : (
              <div style={{ border: "2px dashed #e5e7eb", borderRadius: 8, padding: "30px 20px", textAlign: "center", marginBottom: 16, minHeight: 80, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <span style={{ color: C.gray, fontSize: 13 }}>Signature area — upload in Business Profile</span>
              </div>
            )}
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: C.text }}>For {seller.businessName || "Your Business"}</div>
              <div style={{ fontSize: 12, color: C.gray }}>Authorized Signatory</div>
            </div>
            <div style={{ marginTop: 16, padding: "10px", background: C.grayLt, borderRadius: 8, fontSize: 12, color: C.gray, textAlign: "center" }}>
              This is a computer generated invoice and does not require a physical signature
            </div>
          </Card>
        </div>

        {/* Footer Note */}
        {seller.footerNote && (
          <div style={{ marginBottom: 16, padding: "14px 20px", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 10, fontSize: 13, color: "#92400e", lineHeight: 1.6 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: "#b45309", marginBottom: 4, letterSpacing: 0.5 }}>📋 FOOTER NOTE (from Business Profile)</div>
            {seller.footerNote}
          </div>
        )}

        {/* Page footer */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "13px 20px", background: "#fff", border: `1px solid ${C.border}`, borderRadius: 10, fontSize: 12, color: C.gray }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span>🍁 CRA Compliant</span><span>•</span><span>GST/HST Ready</span><span>•</span><span>Excise Tax Act</span>
          </div>
          <div style={{ display: "flex", gap: 6 }}>
            <span>FinPro Suite — Canada Edition</span>
            <span style={{ color: C.blue, fontWeight: 700 }}>• {currency}</span>
          </div>
        </div>

      </div>
    </div>
  );
}